export const locale = {
    lang: "tr",

    data: {
        COMMON: {
            EMAIL_PLACEHOLDER: "E-postanızı Giriniz",
            PASSWORD_PLACEHOLDER: "Parolanızı Giriniz",
            CONFIRM_PASSWORD_PLACEHOLDER: "Parolanızı Doğrulayınız",
            SUBMIT_CAPS: "Kayıt",
            COMING_SOON: "Yakında gelecek",
            SOON: "Yakın zamanda",
        },

        PLACEHOLDER: {
            ENTER_ORGANISATION: "Organizasyonunuzu Giriniz",
            ENTER_PHONE_NO: "Telefon Numaranızı Giriniz",
            SELECT_PREFERRED_LANGUAGE: "Dil Tercihiniz",
            SELECT_TIMEZONE: "Saat Diliminiz",
            STATE: "Durum",
            STATE_PROVINCE: "İliniz",
            POSTAL_CODE: "Posta Kodu",
            PHONE_NO: "Telefon Numaranız",
            ENTER_POSTAL_CODE: "Posta Kodunuzu Giriniz",
            ENTER_COUNTRY: "Ülke Ara",
            ENTER_STATE: "Arama Durumu",
            ENTER_CITY: "Şehir Girin",
            SEARCH_INDUSTRY: "Sektörlerde Arayınız",
            SEARCH_PREFERRED_LANGUAGE: "Dil Tercihlerinde Arayınız",
            SEARCH_TIMEZONE: "Saat Dilimlerinde Arayınız",
            ENTER_STREET: "Adres Detaylarınızı Giriniz",
            ENTER_FIRST_NAME: "Adınız",
            ENTER_LAST_NAME: "Soyadınız",
            SELECT_DATE_OF_BIRTH: "Doğum Tarihinizi Seçiniz",
        },

        LOGIN: {
            TITLE: "MAKSELLENT Uygulamalarına Hoşgeldiniz!",
            DESCRIPTION:
                "MAKSELLENT Uygulamaları, Sabit Kıymet Yönetim Sistemi ile demirbaşlarınızın yönetimi artık daha kolay...",
            HEADER: "HESABINIZA GİRİŞ YAPINIZ",
            ALREADY_ACCOUNT: "Zaten bir hesabınız varsa lütfen oturum açınız",
            DONTHAVEACCOUNT: "Hesabınız yok mu?",
            CREATEACCOUNT: "Hesap oluştur",
            REGISTERCOMPANY: 'Kurumsal Demo Kayıt',
            EMAIL: "E-posta",
            PASSWORD: "Şifre",
            PASSCONFIRM: "Şifre (Teyit)",
            REMEMBERME: "Beni Hatırla",
            FORGOTPASSWORD: "Şifrenizi mi unuttunuz?",
            SIGNIN: "Oturum açın",
            SIGN_IN: "OTURUM AÇ",
            SIGNUP: "Üye olun",
            SIGN_UP: "ÜYE OL",
            LANGUAGE: "Dil",
            OR_SIGN_IN_WITH: "Alternatif Giriş",
            SIGN_IN_WITH_GOOGLE: "Google ile Giriş",
            SYNC_WITH_GOOGLE: "Google ile senkronize et",
        },

        REGISTER: {
            SIGN_UP: "Kaydol",
            LOGIN_INFORMATION: "Giriş Bilgileriniz",
            PROFILE_INFORMATION: "Profil Bilgileriniz",
            CONTACT_INFORMATION: "İletişim Bilgileriniz",
            ADDRESS_INFORMATION: "Adres Bilgileriniz",
            NEXT: "SONRAKİ",
            ALREADY_ACCOUNT_SIGNUP: "Zaten hesabınız var mı?",
            BACK: "GERİ",
            HEADER: "YENİ HESAP OLUŞTUR",
            STEPFIRST: "Sisteme giriş bilgilerinizi doldurunuz",
            STEPPROFILE: "Profil bilgilerinizi doldurunuz",
            STEPCONTACT: "İletişim bilgilerinizi doldurunuz",
            STEPADDRESS: "Adres bilgilerinizi doldurunuz",
            STEPDONE: "Son",
            FIRSTNAME: "İsim",
            LASTNAME: "Soyad",
            ORGANIZATION: "Organizasyonunuz",
            DATEofBIRTH: "Doğum Tarihi",
            USERNAME: "Kullanıcı Adı",
            GENDER: "Cinsiyet",
            FEMALE: "Kadın",
            MALE: "Erkek",
            EMAIL: "E-Posta",
            PHONENUMBER: "Telefon Numaranız",
            PREFEREDLANG: "Dil Tercihi",
            ADDRESSCOUNTRY: "Ülkeniz",
            ADDRESSCITY: "İlçeniz",
            ADDRESSSTREET: "Adres Detaylarınız",
            HAVEACCOUNT: "Zaten bir hesabınız var mı?",
            ACCEPT_TERMS: "Kabul ediyorum",
            TERMS: "Şartlar ve Koşullar",
            VERIFY: "DOĞRULAYIN",
            SIGNUP_SUCCESSFULLY: "Kayıt Başarılı",
            SENT_ACTIVATION_CODE: "Aşağıdaki e-postanıza gönderilmiş bir aktivasyon kodu var.",
            RETRY: "Eğer e-posta ulaşmadıysa, tekrar denemek için",
            MINUTES: "dakika.",
            RESEND_LINK: "YENİDEN GÖNDER",
            SIGNUP_COMPLETED: "Kaydınızı başarıyla tamamladınız.",
            VERIFING_YOUR_ACCOUNT: "Hesabınızı Doğrulayın",
            LINK_EXPIRED:
                "Aktivasyon linkimizin süresi doldu, yeni aktivasyon linki almak için lütfen tekrar gönder'e tıklayın.",
            AND: "Ve",
        },

        RECOVER: {
            TITLE: "Parolanızı mı unuttunuz",
            HEADER: "Şifreni kurtar",
            GOBACK: "Girişe geri dön",
        },

        RESETPASS: {
            HEADER: "Parolanızı Sıfırlayın",
            DESCRIPTION_OTP: "E-postanıza gönderilen 6 haneli OTP'yi girin",
        },

        BOTTON: {
            ADD: "Ekle",
            CREATE: "Oluştur",
            SAVE: "Kaydet",
            SAVE_AS: "Farklı Kaydet",
            CREATE_REPORT: "Rapor Oluştur",
            EDIT: "Düzenle",
            DELETE: "Sil",
            FILTER: "Filtre",
            RESET: "Reset",
            MAIN: "Asıl",
            LOGIN: "GİRİŞ YAP",
            LOGINLINK: "Giriş Yap",
            PASSWORDRESETLINK: "RESET LİNKİNİ GÖNDER",
            PASSWORDRESETBUTTON: "ŞİFREMİ RESETLE",
            CREATEACCOUNT: "HESAP OLUŞTUR",
            BACK: "Geri",
            NEXT: "İleri",
            SUBMIT: "Gönder",
            CANCEL: "İptal",
            CLOSE: "Kapat",
            UPDATE: "Güncelle",
            REMOVE: "Kaldır",
            UPLOAD: "Yükle",
            COLORTAG: "Renk Etiketi",
        },

        DEMO_ACTIVATION: {
            TITLE: "İş Yönetim Uygulamaları",
            DESCRIPTION:
                "Değer teklifimizi daha iyi anlamanızı istiyoruz. Demo dönemini etkili bir şekilde değerlendirmek için lütfen uygulamanın tüm yönlerini kullanınız ve desteğimize ihtiyacınız duyduğunuzda bize ulaşınız.",
            ALREADY_ACCOUNT: "Eğer kurumsal hesabınız varsa, ",
            BENEFITS_ONE: "3 Ay Ücretsiz Kullanım",
            BENEFITS_TWO: "Kredi kartı yok",
            BENEFITS_THREE: "Taahhüt yok",
            TRY_NOW_BTN: "ŞİMDİ DENE",
            COMPANY_NAME_LABEL: "Şirket Adı",
            COMPANY_NAME_PLACEHOLDER: "Şirket Adını Girin",
            SECTOR_LABEL: "Sektör",
            ACTIVATION_CODE: "E-posta adresinize bir aktivasyon kodu gönderdik",
            INBOX_MSG: "Gelen kutunuza e-posta gelmemesi durumunda",
            ANOTHER_ACTIVATION_CODE:
                "dakika, başka bir aktivasyon kodu almak için lütfen tıklayın.",
            ADDITIONAL_MSG:
                "Ayrıca diğer şirket kullanıcılarının gmail, hotmail, yahoo türü genel e-posta hesapları kullanacaklarsa, uygulamaya kayıt sırasında kullanmaları gereken şirket etkinleştirme kodunu içeren ayrı bir e-posta için lütfen gelen kutunuzu kontrol edin.",
            THANK_YOU: "Teşekkür ederim!",
            REGISTRATION_COMPLETED: "Hesap kaydınızı başarıyla tamamladınız.",
        },

        DIALOG: {
            NAMEREQUIRED: "İsim gerekli alan",
            LASTNAMEREQUIRED: "Soyad gerekli alan",
            ORGANIZATIONREQUIRED: "Organizasyon bilgisi gerekli alan",
            EMAILREQUIRED: "E-posta gerekli alan",
            EMAILWARN: "Lütfen geçerli bir e-posta adresi girin",
            EMAILMUSTCONTAIN:
                "Şunları içermeli (0,9) ve [a,z] ve [A,Z] ve [!@#$%^&?_-|+>;€~¨] ve en az 6 yada daha fazla karakter olmalı.",
            PASSWORDREQUIRED: "Şifre gerekli alan",
            PASSWORDCONFIRMREQUIRED: "Şifre teyit/konfirmasyon gerekli",
            PASSWORDWARN: "Lütfen geçerli bir şifre girin",
            DATEOFBIRTHREQUIRED: "Doğum tarihi gerekli alan",
            DELETEWARN: "Bu kaydı silmek istediğinizden, emin misiniz?",
            DELETESUCCESS: "Kayıt başarılı şekilde silindi!",
            DELETEFAILURE: "Kayıt silinemedi!",
            EDITABANDONED:
                "Değişiklikleriniz kaydedilmeyecek. Çıkmak istediğinizde emin misiniz?",
            EDITSUCCESS: "Kayıt başarılı şekilde kaydedildi!",
            CREATESUCCESS:
                "Kayıt başarılı şekilde oluşturuldu. Lütfen E-Posta adresinizi doğrulayın!",
        },

        HEADER: {
            MY_TASKS: "Görevlerim",
            MY_ASSETS: "Demirbaşlarım",
            MY_ACCOUNTS: "Hesaplarım",
            MY_SHORTCUT: "Kısayolum N",
        },

        SIDEBAR: {
            TASKS: "Görevler",
            FIX_ASSETS: "Duran Varlıklar",
            ACCOUNTS: "Hesaplar",
            SURVEY: "Anket",
            PRODUCTS: "Ürünler",
            CONTACT: "İletişimdekiler",
        },

        SYSTEM_SETTINGS_MENU: {
            MODULES: "Modüller",
            ROLES: "Roller",
            INDUSTRY: "Endüstri",
            STATUS: "Durum",
            LANGUAGE: "Dil",
        },

        SYSTEM_SETTINGS_MODULES: {
            SETTINGS: "Ayarlar",
            SEQUENCE: "Sıra",
            NAME: "İsim Soyisim",
            CODE: "Kodu",
            DESCRIPTION: "Açıklama",
            ACTION: "Aksiyon",
            ACTIVATE: "Etkinleştir",
            DEACTIVATE: "Devre dışı bırak",
            SHOW_FILTER: "Filtreyi Göster",
            HIDE_FILTER: "Filtreyi Gizle",
            CLEAR_FILTER: "Filtreyi Temizle",
            RESULTS_FOUND: "sonuçlar bulundu",
            ENTER_NAME: "İsim giriniz",
            ENTER_CODE: "Kodu girin",
            ENTER_DESCRIPTION: "Açıklama Giriniz",
            ARE_YOU_SURE: "Açıklama Girin",
            ARE_YOU_SURE_DELETE: "Silmek istediğinizden emin misiniz",
            LANGUAGE_QUESTION_MARK: "Dil?",
            ADD: "EKLE",
            CSS_ICON: "CSS Simgesi",
            ENTER_CSS_ICON: "CSS Simgesini Girin",
            ASSIGN_MODULE: "Modülü Ata",
            ASSIGN_ROLE: "Rol Ata",
            WARNING_ROLE:
                "Henüz hiçbir modül eklenmedi. Lütfen role atanacak modülü ekleyin.",
            WARNING_MODULE:
                "Henüz hiçbir rol eklenmedi. Lütfen modüle atanacak rol ekleyin.",
            MODULE: "Modül",
            ROLE: "Rol",
        },

        SURVEY_MODULES: {
            SURVEY: "Anket",
            DOWNLOAD: "İndir",
            SHOW_FILTER: "Filtreyi Göster",
            HIDE_FILTER: "Filtreyi Gizle",
            CLEAR_FILTER: "Filtreyi Temizle",
            ADD: "EKLE",
            EDIT: "DÜZENLE",
            PREVIEW: "ÖN İZLEME",
            RESPONSES: "CEVAPLAR",
            DELETE: "SİL",
            CREATE_NEW: "Yeni Anket Oluştur",
            ADD_PAGE: "Yeni Sayfa Ekle",
            DRAFT: "Taslak Olarak Kaydet",
            DELETE_PAGE: "Sayfayı Sil",
            SAVE_PAGE: "Sayfayı kaydet",
            ADD_QUESTION: "Yeni Soru Ekleyiniz",
            NO_SURVEY: "Henüz herhangi bir anket oluşturulmadı",
            TYPE: "Tip",
            ACCESS_TYPE: "Erişim Tipi",
            SIZE: "Büyüklük",
            BUDGET: "Bütçe",
            NO_SURVEY_TEXT:
                "İlk anketinizi oluşturmak için heyecanlı mısınız? Hemen başlayalım!",
            ADD_SURVEY: "ANKET EKLE",
            ONLY_MY_SURVEY: "Sadece Benim Anketim",
            MEMBER_LIST: "Üye Listesi",
            RESET_ALL: "Hepsini sıfırla",
            MENU: {
                BASIC_DETAIL: "Temel Detaylar",
                DESIGN: "Anket Tasarım",
                PREVIEW: "Ön İzleme",
                RESPONSE: "Cevaplar",
                RESULT: "Sonuç",
                SUMMARY: "Özet",
                DETAILS: "Detaylar",
            },
            PLACEHOLDER: {
                ENTER_SURVEY_NAME: "Anket Adını Giriniz",
                SELECT_SURVEY_TYPE: "Anket Türünü Seçiniz",
                SELECT_ACCOUNT: "Hesap Seçin",
                SELECT_ORGANIZATION: "Kuruluş Seçiniz",
                SELECT_LOCATION: "Konum Seçiniz",
                START_DATE: "Başlangıç tarihi",
                END_DATE: "Bitiş tarihi",
                CREATED_BY: "Oluşturan",
                MODIFIED_BY: "Değiştiren",
            },
            VALIDATION: {
                QUESTION_REQUIRED: "Bu soru boş geçilemez",
            },
        },

        IDEA: {
            IDEA_MANAGEMENT: "Fikir Yönetimi",
            TOTAL_IDEAS: "Tüm Fikirler",
            ADD_IDEA: "FİKİR EKLE",
            ADD_IDEA_SMALL: "Fikir Eklyine",
            CATEGORY: "Kategori",
            SUBMITTED_BY: "Tarafından gönderilmiştir",
            SUBMITTED_ON: "Gönderilme Tarihi",
            ATTACHMENTS: "EKLER",
            COMMENTS: "YORUMLAR",
            UPVOTE: "UPVOTE",
            LIKE: "BEĞEN",
            GIVE_YOUR_COMMENT: "YORUMUNUZU PAYLAŞIN",
            FILTERS: "Filtreler",
            SELECT_CATEGORY: "Kategori seçiniz",
            TITLE: "Başlık",
            ENTER_TITLE: "Başlık Giriniz",
            DESCRIPTION: "Açıklama",
            ENTER_YOUR_IDEA_DESCRIPTION: "Açıklamanızı Giriniz",
            ATTACHMENT: "Ek dosya",
            SELECT_ATTACHMENT: "Ek Seçininiz",
            SEARCH_IDEA: "Fikirlerde Ara",
            ENTER_IDEA_NAME: "Fikir Başlığını Giriniz",
            ONLY_MY_IDEA: "Sadece Benim Fikrim",
            VIEW_MORE: "DAHA FAZLA GÖSTER",
            SAVE: "KAYDET",
            CANCEL: "İPTAL",
            SELECT_START_DATE: "Başlangıç ​​Tarihini Seçiniz",
            SELECT_END_DATE: "Bitiş Tarihini Seçiniz",
            NO_ANY_IDEA_ADDED: "Herhangi bir fikir eklenmedi",
            NO_ANY_IDEA_DESC:
                "İlk görevinizi oluşturmak için heyecanlı mısınız? Hemen atlayalım!",
        },

        PACKAGE: {
            SETTINGS: "Ayarlar",
            MONTHLY: "Aylık",
            ANNUALLY: "Yıllık",
            ASSIGN_MODULES: "ATAMA MODÜLLERİ",
            ACTIVE: "Aktif",
            DEACTIVE: "Deaktif",
            USER_MANAGEMENT: "Kullanıcı yönetimi",
            ADD_FREE_TEXT: "ÜCRETSİZ METİN EKLE",
            DELETE_PACKAGE: "PAKETİ SİL",
            PACKAGE: "Paket içeriği",
            PLAN_TYPE: "Plan Türü",
            SELECT_PLAN_TYPE: "Plan türünü seçin",
            PRICE: "Fiyat",
            ENTER_PRICE: "Fiyat girin",
            FREE_TEXT_IN_PACKAGE: "paketteki serbest metin",
            TEXT: "Metin",
            ENTER_TEXT: "Metin Girin",
            BUY_PLAN: "Plan Satın Al",
            CHOOSE_PLAN: "Plan Seçin",
            ORDER_DETAILS: "sipariş detayları",
            COMPANY_DETAILS: "Şirket Detayları",
            PAYMENT_DETAIL: "Ödeme detayları",
            PER_USER: "Kullanıcı Başına",
            BUY_NOW: "Şimdi al",
            USERS: "Kullanıcılar",
            CHANGE: "DEĞİŞİKLİK",
            BASIC_PACKAGE: "Temel paket",
            ORDER_SUMMARY: "sipariş özeti",
            BASIC_PLAN: "Temel Plan",
            SUB_TOTAL: "Ara toplam",
            GRAND_TOTAL: "Genel Toplam",
            ADDRESS_STREET: "Sokak adresi",
            ENTER_ADDRESS_STREET: "Adres Sokak Girin",
            COUNTRY: "Ülke",
            SELECT_COUNTRY: "Ülke",
            SELECT_STATE: "İl Seçin",
            SELECT_CITY: "İlçe Girin",
            LEGAL_ENTITY: "Tüzel Kişi",
            PRIVATE_COMPANY: "Özel şirket",
            TAX_OFFICE: "Vergi Dairesi",
            ENTER_TAX_OFFICE: "Vergi Dairesi",
            TAX_ID: "Vergi numarası",
            NATIONAL_ID: "Ulusal Kimlik",
            ENTER: "Giriş",
            OFFICE_PHONE_NO: "Ofis Telefon no.",
            ENTER_OFFICE_PHONE_NO: "Ofis Telefon numarasını girin.",
            MOBILE_NO: "Telefon numarası.",
            ENTER_MOBILE_NO: "Cep telefonu numarasını girin.",
            Fax: "Faks",
            ENTER_FAX: "Faks Girin",
            CREDIT_CARD: "Kredi kartı",
            NET_BANKING: "Net Bankacılık",
            CARD_HOLDER_NAME: "Kart Sahibinin Adı",
            ENTER_CARD_HOLDAR_NAME: "Kart Sahibinin Adını Girin",
            CARD_NUMBER: "Kart numarası",
            ENTER_CARD_NUMBER: "Kart Numarasını Girin",
            MM: "MM",
            YYYY: "YYYY",
            CVC: "CVC",
            ENTER_CVC: "CVC'yi girin",
            NOTE: "Not",
            ORDER_NUMBER: "Sipariş numarası",
            NET_BANKING_TITLE:
                "MAKSELLENT LTD. - Havale / EFT banka hesabı bilgileri",
            NET_BANKING_CONTENT: "Yapı & Kredi Bankası (USD Hesabı)",
            IBAN_TOP: "IBAN: TR22 0006 7010 0000 0044 1380 97",
            IBAN_BOTTOM: "IBAN: TR83 0006 7010 0000 0088 0942 95",
            NOTE_DESCRIPTION_TOP:
                "Havale / EFT işlemi tamamlandıktan sonra satın alma işlemi tamamlanacaktır. Lütfen belirtiniz",
            NOTE_DESCRIPTION_BOTTOM:
                "Havale / EFT açıklamasındaki sipariş numarası.",
        },

        VALIDATION: {
            EMAIL_REQUIRED: "Lütfen geçerli bir e-posta adresi giriniz",
            PASSWORD_REQUIRED: "Şifreniz gereklidir",
            PASSWORD_MIN_LENGTH:
                "Şifreniz en az 8 karakter uzunluğunda olmalıdır",
            CONFIRM_PASSWORD_REQUIRED: "Parolanızı onaylamanız gerekli",
            CONFIRM_PASSWORD_NOT_MATCHED:
                "Parola ile Parola teyidiniz uyuşmadı!",
            VALID_INDUSTRY: "Lütfen geçerli endüstri seçiniz",
            VALID_COUNTRY: "Lütfen geçerli bir ülke seçiniz",
            VALID_STATE: "Lütfen geçerli bir eyalet seçiniz",
            VALID_LANGUAGE: "Lütfen geçerli bir dil seçiniz",
            VALID_TIMEZONE: "Lütfen geçerli bir saat dilimi seçiniz",
            NAME_REQUIRED: "İsminiz gerekli",
            CONFIRM_ADD_DATA: "Yeni Veri Eklemek istediğinizden emin misiniz?",
            CONFIRM_ARCHIVE_DATA:
                "Verileri Arşivlemek istediğinizden emin misiniz?",
            CONFIRM_UNSAVED_CHANGE:
                "Kaydedilmemiş değişiklikler kaybolacak. Devam edeceğinizden emin misiniz?",
            CONFIRM_TITLE: "Emin misin",
            CONFIRM_TITLE_UNSAVED_CHANGE: "Kaydedilmemiş Değişiklik",
            PLEASE_ENTER_VALID_EMPLOYEE_TYPE:
                "Lütfen geçerli çalışan türünü girin",
            PLEASE_ENTER_VALID_DEPARTMENT: "Lütfen geçerli departman girin",
            PLEASE_ENTER_VALID_COST_CENTRE:
                "Lütfen geçerli bir maliyet merkezi girin",
            PLEASE_ENTER_VALID_ACCOUNT: "Lütfen geçerli bir hesap girin",
            PLEASE_ENTER_VALID_ORGANIZATION: "Lütfen geçerli bir kuruluş girin",
            PLEASE_ENTER_VALID_UNIT: "Lütfen geçerli birim girin",
            PLEASE_ENTER_VALID_LOCATION: "Lütfen geçerli bir konum girin",
            PLEASE_ENTER_VALID_ZONE: "Lütfen geçerli bölge girin",
            PLEASE_ENTER_VALID_TASK_NAME: "Lütfen geçerli bir görev adı girin",
            PLEASE_ENTER_VALID_EXPENSE_TYPE_NAME:
                "Lütfen geçerli gider türü adını girin",
            PLEASE_ENTER_VALID_USER_NAME:
                "Lütfen geçerli bir kullanıcı adı girin",
            EXPENSE_CATEGORY: "Gider kategorisi gerekli",
            EXPENSE_TYPE: "Gider türü gerekli",
            PROOF: "Kanıt gerekli",
            USER_NAME: "Kullanıcı adı gerekli",
            ASSIGN_TO: "atama gerekli",
            AMOUNT: "Tutar gerekli",
            PLEASE_ENTER_VALID_BANK: "Lütfen geçerli bir banka girin",
            PLEASE_ENTER_VALID_CURRENCY: "Lütfen geçerli para birimi girin",
            PREFIX_REQUIRED: "Ön ek gerekli"
        },

        APP_SETTINGS: {
            ADD_ACCOUNT: "Hesap Ekle",
            NAME: "İsim Soyad",
            ADD_ZONE: "Bölge Ekle",
            ADD_ORGANIZATION: "Organizasyon Ekle",
            ADD_UNIT: "Birim Oluştur",
            ADD_LOCATION: "Konum Ekle",
            APP_SETTING: "Uygulama Ayarları",
            ADD: "Ekle",
            PROFILE: "Profil",
            ENTER_NAME: "İsim Giriniz",
            TENNANT: "Kiracı",
            STATUS: "Durum",
            DESCRIPTION: "Açıklama",
            ENTER_DESCRIPTION: "Açıklama Girin",
            LOCATION: "Yeri",
            ENTER_LOCATION: "Konum Girin",
            COUNTRY: "Ülke",
            CITY: "Mahalle",
            STREET: "Cadde / Sokak",
            ENTER_STREET: "Cadde / Sokak Girin",
            CONTACT: "İletişim",
            EMAIL: "E-posta",
            ENTER_EMAIL: "E-posta Girin",
            PHONE_NO: "Telefon Yok.",
            ENTER_PHONE_NO: "Telefon Numarasını Giriniz.",
            DOCUMENTS: "Belgeler",
            SELECT_ATTACHMENTS: "Ekleri Seçin",
            ACCOUNT_NAME: "Hesap adı",
            ENTER_ACCOUNT_NAME: "Hesap Adınızı Giriniz",
            ORGANIZATION: "Organizasyon",
            ENTER_ORGANIZATION_NAME: "Kuruluş Adınızı Giriniz",
            ZONE_NAME: "Bölge adı",
            ENTER_ZONE_NAME: "Bölge adını girin",
            MOBILE_NUMBER: "Cep numarası",
            ENTER_MOBILE_NUMBER: "Cep Numaranızı Giriniz",
            SELECT_UNIT_CAPITAL: "Birim Seçiz",
            SELECT_ZONE_CAPITAL: "Bölge Seçiz",
            SELECT_ROLE: "Rol Seçiniz",
            POWER_USER: "Ana Kullanıcı",
            SELECT_ALL: "Hepsini Seç",
            IMPORT: "İçe Aktar",
            MOBILE_NO: "Telefon Numaranız",
            ROLES: "ROLLER",
            MEMBER: "Üye",
            TASK_MANAGER: "Görev Yöneticisi",
            HR_MANAGER: "İK Yöneticisi",
            ASSET_MANAGER: "Varlık yöneticisi",
            FILE_MANAGER: "Dosya yöneticisi",
            LOCATION_CAPITAL: "YER",
            PEPSICO: "pepsiko",
        },

        SURVEY_TARGET: {
            SURVEY_TARGET: "Anket Hedefi",
            ADD_TARGET: "Hedef Ekle",
            ENTER_NAME: "İsim giriniz",
            NO_OF_DATA: "Veri Sayısı",
            IMPORT_DATA: "Verileri İçe Aktar",
            ADD_SURVEY_TARGET: "Anket Hedefi Ekle",
            PREVIOUS_CUSTOMER_LIST: "Önceki Müşteri Listesi",
            SELECT_FILE: "Dosya Seç",
            DOWNLOAD_SAMPLE_FILE: "Örnek Dosyayı İndirin",
            CSV: ".csv",
            XSLX: ".xslx",
            WANT_TO_SAVE_FILE_IN_SYSTEM: "Dosyayı sisteme kaydetmek istiyorum",
            SEND_EMAIL: "Eposta gönder",
            NAME: "İsim Soyisim",
            SURNAME: "Soyadı",
            JOB_TITLE: "İş ismi",
            NATIONAL_ID: "Ulusal Kimlik",
            Description: "Açıklama",
            SEARCH_FIRST_NAME: "Adı ara",
            SEARCH_LAST_NAME: "Soyadı ara",
            SELECT_GENDER: "Cinsiyet seç",
            SEARCH_EMAIL: "E-postada ara",
            SEARCH_PHONE_NO: "Arama telefon numarası",
            CHOOSE_DATE: "Tarih seçin",
        },

        PROFILE: {
            PROFILE: "Profil",
            MYPROFILE: "Profilim",
            PREFERENCES: "Tercihlerim",
            ASSETS: "Demirbaşlarım",
            BANK_ACCOUNT: "Banka Hesabım",
            CHANGE_PASSWORD: "Şifre değiştir",
            CHANGE_PROFILE: "Profili değiştir",
            ADD_PICTURE: "Resim Ekle",
            CHANGE_PICTURE: "Resmi değiştir",
            CHOOSE_DATE: "Tarih Seçin",
            ENTER_NATIONAL_ID: "Ulusal Kimliği Girin",
            UPDATE: "GÜNCELLE",
            RESET: "SIFIRLA",
            OLD_PASSWORD: "eski Şifre",
            ENTER_OLD_PASSWORD: "Eski Şifreyi Girin",
            NEW_PASSWORD: "Yeni Şifre",
            ENTER_NEW_PASSWORD: "Yeni Şifre Girin",
            CONFIRM_PASSWORD: "Şifreyi Onayla",
            DEPARTMENT: "Bölüm",
            SELECT_DEPARTMENT: "Bölüm Seçiniz",
            ORGANIZATION: "Organizasyon",
            SELECT_ORGANIZATION: "Kuruluş Seçin",
            ACCOUNT: "Hesap",
            SELECT_ACCOUNT: "Hesap Seçin",
            EMPLOYEMENT_INFORMATION: "İstihdam Bilgileri",
            EMPLOYEE_ID: "Sicil No",
            ENTER_EMPLOYEE_ID: "Çalışan sicil numarası",
            JOB_TITLE: "Ünvan",
            ENTER_JOB_TITLE: "İş ünvanını girin",
            TYPE_OF_EMPLOYEE: "Çalışan Türü",
            SELECT_EMPLOYEE: "Çalışan Seçiniz",
            MANAGER: "Yönetici",
            SELECT_MANAGER: "Yönetici seçiniz",
            COST_CENTER: "Maliyet Merkezi",
            SELECT_COST_CENTER: "Maliyet merkezini seçin",
            ENTER_ORGANIZATION: "Kuruluşa girin",
            ENTER_UNIT: "Birimi Girin",
            ENTER_ZONE: "Bölgeye Girin",
            OFFICE_NO: "Ofis Telefonu",
            ENTER_OFFICE_NO: "Ofis telefonu giriniz",
            ENTER_PHONE_NUMBER: "Telefon numarasını giriniz",
            PROVINCE_CODE: "Şehir",
            ENTER_PROVINCE_CODE: "Şehir kodunu giriniz",
            EXPENSES: "Masraflarım",
            ONLY_MY: "Sadece benim",
            PAID_EXPENSE: "Ödenen Masraf",
            UNPAID_EXPENSE: "Ödenmemiş Gider",
            TASK_NAME: "Görev adı",
            ASSIGN_TO: "Atanan Kişi",
            AMOUNT: "Miktar",
            PAID_AMOUNT: "Ödenen miktar",
            PAYMENT_DATE: "Ödeme tarihi",
            SELECT_TASK: "Görev seç",
            SELECT: "Seçme",
            ENTER: "Girmek",
            SELECT_USER: "Kullanıcı seç",
            SELECT_PAYMENT_STATUS: "Ödeme Durumunu Seçiniz",
            SELECT_PAYMENT_RANGE: "Ödeme Aralığını Seçiniz",
            SELECT_DATE_RANGE: "Tarih Aralığı Seçiniz",
            SELECT_PAYMENT_TYPE: "Ödeme Türünü Seçiniz",
            PAYMENTS: "Ödemelerim",
            BANK_ACCOUNTS: "Banka hesabı",
            FULL_NAME: "Ad Soyad",
            ENTER_FULL_NAME: "Tam Adınızı Giriniz",
            BANK_NAME: "Banka adı",
            IBAN: "IBAN",
            ENTER_IBAN: "IBAN'ı giriniz",
            CURRENCY: "Para birimi",
            SELECT_CURRENCY: "Para birimini seçin",
            SELECT_BANK: "Banka Seç",
            SELECT_BANK_SMALL: "Banka seçiniz",
            BRANCH_CODE: "Şube Kodu",
            ENTER_BRANCH_CODE: "Şube kodunu giriniz",
            ACCOUNT_CODE: "Hesap kodu",
            ENTER_ACCOUNT_CODE: "Hesap kodunu giriniz",
            ENTER_FULL_NAME_AS_NATIONAL_ID_CARD:
                "Adınızı kimlik kartınızda olduğu gibi giriniz",
            USER_NAME: "Kullanıcı adı",
            SELECT_AMOUNT: "Tutarı Seç",
            SELECT_PAID_AMOUNT: "Ödenen Tutarı Seçin",
            MY_EXPENSES: "Harcamalarım",
            APPROVE_SELECTED: "Seçilenleri Onayla",
            CUSTOMER: "Müşteri",
            CUSTOMER_CAPITAL: "MÜŞTERİ",
            EXPENSE_TYPE: "Gider Türü",
            SELECT_EXPENSE_TYPE: "Gider Türünü Seçin",
            PROOF: "Kanıt",
            SELECT_PROOF: "Kanıt Seç",
            SELECT_USER_NAME: "Kullanıcı adı seçiniz",
            MIN_AMOUNT_PAID: "Ödenen Asgari Tutar",
            SELECT_MIN_AMOUNT_PAID: "Ödenen Minimum Tutarı Seçin",
            MAX_AMOUNT_PAID: "Ödenen Maksimum Tutar",
            SELECT_MAX_AMOUNT_PAID: "Ödenen Maksimum Tutarı Seçin",
            MIN_AMOUNT: "Asgari Tutar",
            SELECT_MIN_AMOUNT: "Minimum Tutarı Seçin",
            MAX_AMOUNT: "Maksimum Tutar",
            SELECT_MAX_AMOUNT: "Maksimum Tutarı Seçin",
            ENTER_YOUR_COMMENT: "yorumunuzu girin",
            CLONE: "Klon",
            APPROVE: "Onaylamak",
            VALID_EXPENSE_CATEGORY:
                "Lütfen geçerli bir gider kategorisi adı girin",
        },

        MY_FILE: {
            UPLOAD_FILE: "Dosya yükle",
            CREATE_FOLDER: "Klasör oluşturun",
            FOLDER_NAME: "Klasör adı",
            ENTER_FOLDER_NAME: "Klasör adını giriniz",
            MY_FILES: "Dosyalarım",
            CREATE_NEW_FOLDER: "Yeni Klasör Oluştur",
            FOLDERS: "KLASÖRLER",
            FILES_SMALL: "Dosyalar",
            FILES_CAPITAL: "DOSYALAR",
            FILE_TYPE: "Dosya tipi",
            FILE_SIZE: "Dosya boyutu",
            UPDATED_BY: "Güncelleyen",
            UPDATED_ON: "Güncelleme Tarihi",
            MODIFIED_ON: "Değiştirilme tarihi",
            ARCHIVE: "Arşiv",
            EMPTY_TRASH_NOW: "Şimdi çöpü boşalt",
            NO_FOLDER_TEXT: "Henüz herhangi bir klasör eklenmedi",
            NO_FILE_TEXT: "Henüz herhangi bir dosya eklenmedi",
            SHARE: "Paylaş",
            DELETE_FOREVER: "Sonsuza Kadar Sil",
            UNDO: "Geri alma",
            TRASH: "Çöp",
            OTHER_INFORMATION: "Diğer bilgiler",
            SELECT_TAGS: "Etiketleri seçin",
            SELECT_ACCESS_MODIFIER: "Erişim değiştiriciyi seçin",
            SELECT_FILES: "Dosyaları Seçiniz",
            MARK_AS_UNFAVOURITE: "Favori olmayan olarak işaretle",
            MARK_AS_MAIN: "Ana olarak işaretle",
        },

        SURVEY_RESULT: {
            SURVEY_RESULT: "Anket sonuçları",
            RESPONDENTS: "CEVAPLAR",
            OF: "nın-nin",
            PRINT: "Yazdır",
            ANSWERED: "Cevaplandı",
            SKIPPED: "Atlandı",
            TOTAL: "TOPLAM",
        },

        FIX_ASSET: {
            THUMBNAIL: "Resim",
            ASSET_CODE: "Varlık Kodu",
            ENTER_ASSET_CODE: "Varlık Kodunu Giriniz",
            BRAND: "Marka",
            MODEL: "Modeli",
            SERIAL_NUMBER: "Seri numarası",
            DEFINITION: "Tanım",
            ENTER_DEFINITION: "Tanımı giriniz",
            MODIFICATION_DATE: "Değiştirme tarihi",
            CATEGORIZATION: "Sınıflandırma",
            CATEGORIZATION_CAPITAL: "SINIFLANDIRMA",
            COMMENT: "Yorum Yapın",
            TRANSFER: "Transfer",
            EXCEL: "Excel",
            CSV: "CSV",
            JSON: "json",
            TXT: "Txt",
            PRODUCT_FAMILY: "Ürün Ailesi",
            ADD_PRODUCT_FAMILY: "Ürün Ailesi Ekleyin",
            ENTER_PRODUCT_FAMILY: "Ürün ailesini giriniz",
            IT_EQUIPMENTS: "BT ekipmanları",
            PRODUCT_CATEGORY: "Ürün Kategorisi",
            ADD_PRODUCT_CATEGORY: "Ürün Kategorisi Ekleyin",
            ENTER_PRODUCT_CATEGORY: "Ürün giriniz",
            COMPUTERS: "Bilgisayarlar",
            PRODUCT_LINE: "Ürün Hattı",
            ADD_PRODUCT_LINE: "Ürün Hattı Ekleyin",
            ENTER_PRODUCT_LINE: "Ürün hattını giriniz",
            LAPTOP: "Dizüstü bilgisayar",
            PRODUCT_TYPE: "Ürün Tipi",
            ADD_PRODUCT_TYPE: "Ürün Tipi Ekleyin",
            ENTER_PRODUCT_TYPE: "Ürün türünü giriniz",
            XSD: "XSD",
            ORGANISATION_HIERARCHY: "Organizasyon Hiyerarşisi",
            ACCOUNT: "Hesap",
            ZONE: "Bölge",
            SELECT_ZONE: "Bölge seç",
            ASSET: "VARLIK",
            ASSET_STATUS: "Varlık Durumu",
            SELECT_ASSET_STATUS: "Varlık durumunu seçiniz",
            ASSET_USAGE: "Varlık Kullanımı",
            ENTER_COMPANY_ASSET_CODE: "Şirket Varlık Kodunu Giriniz",
            COMPANY_ASSET_CODE: "Şirket Varlık Kodu",
            MASTER_ASSET_CODE: "Ana Varlık Kodu",
            ENTER_MASTER_ASSET_CODE: "Ana Varlık Kodunu Giriniz",
            GENERAL: "GENEL",
            STATUS_DETAILS: "Durum Ayrıntıları",
            SELECT_STATUS_DETAILS: "Durum ayrıntısını seçiniz",
            STATUS_DETAIL: "Durum Detayı",
            EMPLOYEE: "Çalışan",
            ADD_BRAND: "Marka Ekleyin",
            ENTER_BRAND: "Marka Giriniz",
            ADD_MODEL: "Model Ekleyin",
            ENTER_MODEL: "Model Giriniz",
            ENTER_SERIAL_NUMBER: "Seri Numarasını Giriniz",
            COMMENTS: "Yorumlar",
            ENTER_COMMENT: "Yorum giriniz",
            BASIC_DEFINITIONS: "Temel tanımlar",
            STATUS_LIABILITY: "Durum/Yükümlülük",
            ADD_STATUS_LIABILITY: "Durum/Yükümlülük Ekleyin",
            MAINTENANCE: "Bakım",
            INSURANCE: "Sigorta",
            FINANCIAL_DETAILS: "Finansallar",
            PHOTOS_DOCUMENTS: "Fotoğraflar/Dosyalar",
            FIRM_ASSET_CODE: "Firma varlık kodu",
            ENTER_FIRM_ASSET_CODE: "Firma varlık kodunu giriniz",
            MAIN_ASSET_CODE: "Ana varlık kodu",
            ENTER_MAIN_ASSET_CODE: "Ana varlık kodunu giriniz",
            EXPLANATION: "Açıklama",
            ENTER_EXPLANATION: "Açıklama giriniz",
            WIDTH: "Genişlik",
            ENTER_WIDTH: "Genişliği giriniz",
            HEIGHT: "Yükseklik",
            ENTER_HEIGHT: "Yüksekliği giriniz",
            LENGTH: "Uzunluk",
            ENTER_LENGTH: "Uzunluğu giriniz",
            QUANTITY: "Miktar",
            ENTER_QUANTITY: "Miktar giriniz",
            UNIT: "Birim",
            SELECT_UNIT: "Birim seçiniz",
            ASSET_LOCATION: "Varlık Konumu",
            START_DATE: "Başlangıç ​​tarihi",
            END_DATE: "Bitiş tarihi",
            LIABLE_EMPLOYEE: "Sorumlu Çalışan",
            SELECT_LIABLE_EMPLOYEE: "Sorumlu çalışan seçiniz",
            ASSET_ATTRIBUTE: "Varlık Özelliği",
            SELECT_ASSET_ATTRIBUTE: "Varlık özelliğini seçiniz",
            TYPE: "Tür",
            VENDOR: "Tedarikçi",
            MAINTENANCE_DATE: "Bakım Tarihi",
            NEXT_MAINTENANCE_DATE: "Sonraki Bakım Tarihi",
            COMPLETION_DATE: "Tamamlama tarihi",
            SET_REMINDER: "Hatırlatıcıyı Kur",
            CUSTOM: "Özel",
            ADD_REMINDER: "Hatırlatıcı Ekleyin",
            CHOOSE_TIME: "Zaman Seçiniz",
            ENTER_NOTE: "Not Giriniz",
            ADD_ASSET_MAINTENANCE: "Varlık Bakımı Ekle",
            MAINTENANCE_TYPE: "Bakım Türü",
            SELECT_MAINTENANCE_TYPE: "Bakım türünü seçiniz",
            MAINTENANCE_VENDOR: "Bakım Şirketi",
            INSURANCE_COMPANY: "Sigorta Şirketi",
            ENTER_INSURANCE_COMPANY: "Sigorta şirketini giriniz",
            POLICY_NUMBER: "Poliçe numarası",
            ENTER_POLICY_NUMBER: "Poliçe numarasını giriniz",
            AGENT_NAME: "Temsilci adı",
            ENTER_AGENT_NAME: "Temsilci adını giriniz",
            POLICY_TYPE: "Poliçe Türü",
            ADD_ASSET_INSURANCE: "Sigorta Ekle",
            SCANNER_CODE: "Tarayıcı kodu",
            GENERATE_NEW_CODE: "YENİ KOD OLUŞTUR",
            QR_CODE: "QR kod",
            BARCODE: "Barkod",
            RFID_CODE: "RFID kodu",
            UNIQUE_KEY: "Benzersiz anahtar",
            SELECT_LOCATION: "Konum Seçin",
            ENTER_POLICY_TYPE: "Poliçe türünü giriniz",
            REMINDER: "Hatırlatma",
            NEXT_WEEK: "Gelecek hafta",
            TOMORROW: "Yarın",
            IN: "İçinde",
            HOURS: "Saatler",
            MINUTES: "Dakika",
            APPLY: "UYGULA",
            UPLOAD: "YÜKLE",
            SEE_ALL_PHOTOS: "TÜM FOTOĞRAFLARI GÖR",
            SHARE: "PAYLAŞ",
            UPLOAD_PHOTO_DOCUMENT: "Fotoğraf/Belge Yükle",
            UPLOAD_PHOTO_DOCUMENT_TEXT:
                "Varlık ana fotoğrafı olarak ayarlamak için herhangi birini seçiniz",
            SEE_ARCHIVE: "Arşivlenmiş Kayıtlar",
            INITIAL_COST: "İlk maliyet",
            ENTER_INITIAL_COST: "Başlangıç ​​maliyetini girin",
            ACQUISTONO_DATE: "Edinme Tarihi",
            BOOK_VALUE: "Kitap Değeri",
            CURRENT_VALUE: "Mevcut değer",
            AMORTIZATION: "amortisman",
            FISCAL_YEAR_END: "Mali yıl sonu",
            ENTER_FISCAL_YEAR_END: "Mali yıl sonunu girin",
            MONTHLY_AMORTISATION: "Aylık amortisman",
            ENTER_MONTHLY_AMORTISATION: "Aylık amortismanı girin",
            MONTHLY_HELD: "Aylık düzenlenen",
            ENTER_MONTHLY_HELD: "Aylık tutulan girin",
            DATE_ACQUIRED: "Edinme tarihi",
            DATE_OF_DISPOSITION: "Tasarruf tarihi",
            PERIOD: "Dönem",
            MONTH_THIS_PERIOD: "Bu dönem ay",
            AMORTIZATION_THIS_PERIOD: "Bu dönemde amortisman",
            ACCUMULATED_AMORTIZATION: "Birikmiş amortisman",
            NET_BOOK_VALUE: "Net defter değeri",
            REVALUATION: "yeniden değerleme",
            INVOICE_COST: "Fatura Maliyeti",
            REVALUATION_FACTOR: "Yeniden Değerleme Faktörü(%)",
            REVALUATION_DATE: "Yeniden Değerleme Tarihi",
            SELECT_UNIT_CAPITAL: "Birim Seç",
            NO_FIX_ASSETS_DESC:
                "İlk sabit varlığınızı oluşturmak için heyecanlı mısınız? Hemen atlayalım!",
            ADD_ASSETS: "DEMİRBAŞ EKLE",
            CLONE_ASSET: "Demirbaşı Klonla / Çoğalt",
            NAME: "Kısa Tanım",
            DESCRIPTION: "Açıklama",
            SHARE_FILES: "Dosyaları Paylaş",
        },

        TASK_MANAGEMENT: {
            PROJECT_MEMBERS: "Proje Üyeleri",
            TEAM: "Takımlar",
            NO_ANY_TEAM_ARE_AVAILABLE: "Herhangi bir takım mevcut değil",
            build_a_team_and_add_resources:
                "Bir ekip oluşturun ve kaynaklar ekleyin.",
            BUILD: "YAPI",
            CREATE: "OLUŞTUR",
            CREATE_TEAM: "Takım oluştur",
            EDIT_TEAM: "Takımı düzenle",
            TEAM_NAME: "Takım adı",
            ENTER_TEAM_NAME: "Takım adını girin",
            SEARCH_USERS: "Kullanıcı ara",
            INVITE: "DAVET ET",
            SR_NO: "Bay Hayır.",
            MEMBERS: "Üyeler",
            CREATE_NEW_BOARD: "Yeni pano oluştur",
            UPDATE_BOARD: "Panoyu güncelle",
            BOARD_NAME: "Pano adı",
            ENTER_BOARD_NAME: "Pano adını girin",
            CHOOSE_BACKGROUND: "Arkaplan seç",
            REMOVE_FROM_FAVOURITE: "Favoriden kaldır",
            DELETE_BOARD: "Panoyu sil",
            NAME_YOUR_PROJECT: "Projenize bir isim verin",
            CREATE_PROJECT_TEXT:
                "Bu ayrıntıları istediğiniz zaman proje ayarlarınızda değiştirebilirsiniz.",
            PROJECT_NAME: "Proje Adı",
            ENTER_PROJECT_NAME: "Proje adını giriniz",
            PREFIX: "Önek",
            ENTER_PREFIX: "Ön ek giriniz",
            TYPE_OF_PROJECT: "Proje türü",
            LIMIT_OF_RESOURCES: "Kaynak limiti",
            COLOR: "Renk",
            PRIVATE_PROJECT: "Özel proje",
            SAVE_NEXT: "KAYDET & İLERİ",
            NO_ANY_USERS_ARE_AVAILABLE: "Herhangi bir kullanıcı mevcut değil",
            INVITE_USERS_TEXT:
                "Kullanıcıyı şimdi davet edin ve herhangi bir projeye ekleyin.",
            VIEW_PROFILE: "Profili Görüntüle",
            INVITE_USER: "Kullanıcıyı davet et",
            INVITE_TEAMMATES: "Takım arkadaşlarını davet et",
            ENTER_EMAIL_ADDRESSES: "E-posta adreslerini girin",
            MESSAGE: "İleti",
            MESSAGE_PLACEHOLDER: "Davetinize kişisel bir mesaj ekleyin",
            INVITE_SMALL: "Davet etmek",
            MANAGE_TEAM_FOR: "için ekibi yönet",
            ADD_TEAMMATES: "Takım arkadaşları ekle",
            ENTER_TEAMMATES: "Takım arkadaşlarını girin",
            PROJECTS: "Projeler",
            NO_PROJECT: "Henüz herhangi bir proje eklenmedi",
            NO_PROJECT_TEXT:
                "İlk projenizi oluşturmak için heyecanlı mısınız? Hemen başlayalım!",
            ADD_PROJECT: "PROJE EKLE",
            SEE_MEMBERS: "ÜYELERİ GÖR",
            VIEW_TASKS: "Görevleri görüntüle",
            MANAGE_TEAM: "Ekibi yönet",
            KEY: "Anahtar",
            CREATED_BY: "Oluşturan",
            BOARD: "Pano",
            ADD_MEMBERS: "Üye ekle",
            SHARE_TASK: "Görevi paylaş",
            NAME_OR_EMAIL: "Ad veya e-posta",
            ENTER_NAME_OR_EMAIL: "Ad veya e-posta girin",
            ADD_A_MESSAGE: "Mesaj Ekle",
            FLAGGED: "İşaretli",
            EDIT_TASK: "Görevi düzenle",
            EDIT_COLOR: "Rengi düzenle",
            CONVERT_TO_SUB_TASK: "Alt göreve dönüştür",
            COPY_TASK_LINK: "Görev bağlantısını kopyala",
            MOVE_IN: "Taşınmak",
            DUPLICATE_TASK: "Aynısını Oluştur",
            ADD_FLAG: "İşaret ekle",
            REMOVE_COLOR_TAG: "Renk Etiketini Kaldır",
            ENTER_TASK_BRIEF: "Görev Özetini Girin",
            ADD_SUBTASK: "Alt Görev Ekle",
            CHECKLIST: "Kontrol listesi",
            ASSIGNEE: "Atanan",
            UNASSIGNED: "Atanmamış",
            REPORTER: "Raporlanan",
            TAGS: "Etiketler",
            ENTER_NEW_TAG: "Yeni etiket giriniz",
            PRIORITY: "Öncelik",
            DUE_DATE: "Bitiş tarihi",
            CREATED: "Oluşturuldu",
            UPDATED: "Güncellendi",
            RESOLVED: "Çözüldü",
            ACTIVITY: "Aktivite",
            NEWEST_FIRST: "En yeni ilk",
            OLDEST_FIRST: "Önce en eski",
            ALL: "Tüm",
            HISTORY: "Tarihçe",
            TYPE_A_COMMENT: "Bir yorum yazın",
            DELETE_ALL: "Hepsini sil",
            DOWNLOAD_ALL: "Hepsini indir",
            ATTACHMENT_TEXT: "Herhangi bir ek eklenmedi",
            ADD_AN_ITEM: "Öğe ekle",
            ADDED: "Eklendi",
            CHANGED: "Değişti",
            HISTORY_CAPITAL: "TARİHÇE",
            IN_PROGRESS: "Devam etmekte",
            COMMENT_CAPITAL: "YORUM",
            SUB_TASKS: "Alt görevler",
            MARK_AS_FAVOURITE: "Favori olarak işaretle",
            OPEN_BOARD: "Açık Tahta",
            ADD_SECTION: "Bölüm Ekle",
            ADD_TASK: "GÖREV EKLE",
            SEARCH: "Arama",
            ONLY_MY_ISSUE: "SADECE BENİM KONUM",
            RECENTLY_UPDATED: "YENİ GÜNCELLENDİ",
            LABEL: "ETİKET",
            TASK: "Görev",
            SUBTASK: "Alt Görev",
            COLOR_CAPITAL: "RENK",
            CLEAR_FILTERS: "FİLTRELERİ TEMİZLE",
            GROUP_BY: "GRUP TARAFINDAN",
            COMPLETED: "Tamamlanmış",
            INCOMPLETED: "Eksik",
            RENAME: "Yeniden isimlendirmek",
            ENTER_TEXT: "Metin girin",
            ASSIGN_TEAM: "Takım ata",
            ASSIGN_MEMBER: "Üye ata",
            MARK_AS_MILESTONE: "Kilometre Taşı olarak işaretle",
            ENTER_TASK_NAME: "Görev adını giriniz",
            TAG: "ETİKET",
            PRODUCT_MANAGEMENT: "Ürün Yönetimi",
            PROJECT_TYPE: "Proje tipi",
            PROJECT_KEY: "Proje Anahtarı",
            SEARCH_PROJECT_KEY: "Proje Anahtarını Ara",
            PUBLIC_PROJECT: "Genel Proje",
            MODIFIED_BY: "Değiştiren",
            ONLY_MY_PROJECT: "Sadece Benim Projem",
            SHOW_ONLY_FAVOURITE: "Yalnızca Favorileri Göster",
            PRIVATE: "Özel",
            PUBLIC: "Genel",
            DEFAULT: "Varsayılan",
            STATUS_CAPITAL: "DURUM",
            CREATED_ON: "tarihinde oluşturuldu",
            QUICK_CREATE_TEAM: "Takım Oluştur",
            TEAM_DESCRIPTION: "Takım Tanımı",
            PICK_MEMBERS: "Üye seç",
            SELECT_MEMBERS: "Üyeleri seçin",
            VISIBILITY: "görünürlük",
            ACCESS_MODIFIER: "Erişim Değiştirici",
            TEAMS: "Takımlar",
            UI_UX_TEAM_MEMBERS: "(UI/UX ekip üyeleri)",
            ADD_BOARD: "Pano ekle",
            SELECT_TEAM: "Takım seçin",
            ADD_TEAM: "Ekip ekle",
            SEARCH_TO_ADD_MEMBER_TO_TEAM: "Takıma üye eklemek için ara",
            SELECT_ALL_CAPITAL: "HEPSİNİ SEÇ",
            NO_ANY_MEMBERS_ARE_ADDED: "Hiçbir üye eklenmedi",
            PICK_FROM_USERS_LIST_AND_ASSIGNED_IN_TO_THE_TEAM:
                "Kullanıcılar listesinden seçin ve ekibe atanın",
            ADD_ATTACHMENT: "Ek ekle",
            ADD_CHECKLIST: "Kontrol listesi ekle",
            TASK_ESTIMATION: "Görev tahmini(saat olarak)",
            ADD_DESCRIPTION: "Bir açıklama ekle",
            ENTER_TASK_ESTIMATION: "Görev tahminini girin",
            NONE: "Hiçbiri",
            PROGRESS: "İlerleme",
            ADD_EXPENSE: "Gider Ekle",
            EXPENSE_TYPE: "Gider Türü",
            SELECT_EXPENSE_TYPE: "Gider Türünü Seçin",
            EXPENSE_AMOUNT: "Gider Tutarı",
            ENTER_EXPENSE_AMOUNT: "Harcama Tutarını Girin",
            ARCHIVE_BOARD: "Arşiv Panosu",
            SHOW_USERS_TEAM: "Kullanıcıları/Ekipleri Göster",
            SHOW_TEAM: "Takımı göster",
            EXPENSE_CATEGORY: "Gider Kategorisi",
            TO_DO: "Yapılacaklar",
            ALL_TASK_MANGEMENT: "Tüm",
            SECTION: "Bölüm",
            SELECT_PROJECT: "Proje Seç",
            ONLY_CREATED_BY_ME: "Sadece benim oluşturduklarım",
            ONLY_ASSIGNED_TO_ME: "Sadece bana atananlar",
            ONLY_REPORTED_TO_ME: "Sadece bana raporlananlar",
            ONLY_ME_AS_A_TEAM_MEMBER: "Ekip üyesi olarak sadece ben",
            IN_PROGRESS_CAPITAL: "DEVAM ETMEKTE",
            DONE: "TAMAMLANAN",
            TO_DO_CAPITAL: "YAPILACAK",
            DUE_ON: "vade tarihi",
            REPORT_NAME: "Rapor Adı",
            SELECT_REPORT_NAME: "Rapor adını seçin",
            NAME: "İsim",
            CONTACT_DETAILS: "İletişim detayları",
            USE_COMMA_TO_SEPERATE_INVITATION_ACCOUNTS: "Davet hesaplarını ayırmak için virgül kullanın",
            FAVORITE: "Favori",
            RECURRING: "yinelenen",
            SELECT_DUE_DATE: "Son Tarih Seçin",
            NAVIGATIONAL: "SEYİR",
            SELECT_BOARD: "Pano Seç",
            SELECT_SECTION: "Bölüm Seç",
            PARENT: "ebeveyn",
            SELECT_PARENT: "Ebeveyn Seç",
            OWNERSHIP_MEMBERSHIP: "MÜLKİYET/ÜYELİK",
            REPORTED_TEAM: "Raporlanan Ekip",
            SELECT_REPORTED_TEAM: "Bildirilen Ekibi Seçin",
            OWNER_USER: "Sahibi",
            SELECT_OWNER_USER: "Sahibi Seç",
            REPORTED_USER: "Raporlanan Kullanıcı",
            SELECT_REPORTED_USER: "Raporlanan Kullanıcıyı Seç",
            ASSIGNED_USER: "Atanan Kullanıcı",
            SELECT_ASSIGNED_USER: "Atanan Kullanıcıyı Seç",
            SELECT_CREATED_BY: "Oluşturanı Seç",
            SELECT_MODIFIED_BY: "Değiştireni Seç",
            TASK_CATEGORY: "Kategori",
            SELECT_CATEGORY: "Kategori Seç",
            TASK_SUB_CATEGORY: "Alt Kategori",
            SELECT_SUB_CATEGORY: "Alt Kategori Seç"
        },

        DASHBOARD_FIX_ASSETS: {
            WELCOME: "Hoş geldin",
            BRANDS: "Markalarına Göre Miktarları",
            CATEGORY_COUNT: "Kategorilerine Göre Miktarları",
            ASSET_BYSTATUS_COUNT: "Durumlarına Göre Miktarları",
            COUNT: "Miktar",
            NOTIFICATIONS: "Bildirimler",
            REMINDERS: "Hatırlatıcılar",
            ADDED: "katma",
            A: "a",
            ON: "üzerinde",
            UPVOTE: "olumlu oy",
            SHOW_MORE: "Daha fazla göster",
            DUE_INSURANCE: "Vadesi gelen sigorta",
            DATE: "Tarih",
            DUE_MAINTENANCE: "Bakım zamanı",
            NO_NOTIFICATION: "Yakın zamanda herhangi bir bildirim yok",
            NO_REMINDER: "Yakın zamanda herhangi bir hatırlatıcılar yok",
            NO_INSURANCE: "Herhangi bir sigorta bulunamadı",
            NO_MAINTENANCE: " Herhangi bir bakım bulunamadı",
            NO_DATA: "Herhangi bir veri bulunamadı",
        },

        SYSTEM_NAVIGATION: {
            HOME: "Ana Sayfa",
            DASHBOARD: "Gösterge Paneli",
            MY_SURVEY: "Anketlerim",
            MY_IDEAS: "Fikirlerim",
            TENANTS: "Kiracılar",
            MY_PROFILE: "Profilim",
            LOGOUT: "Çıkış Yap",
            TASK_MANAGEMENT: "Görev Yönetimi",
            TASK_MANAGEMENT_DESC:
                "Görevlerinizi yaşam döngüsü içinde yönetin. Planlayın, test edin, takip edin ve raporlayın. Bireysel hedeflerinize ulaşın veya takım arkadaşlarınızla işbirliği yapın.",
            SURVEY_MANAGEMENT: "Anket Yönetimi",
            SURVEY_MANAGEMENT_DESC:
                "Profesyonel anketler tasarlayın, yönetin ve yayınlayın ve iş karar verme sürecinizde yardım sağlamak için geri bildirim toplayın.",
            FIX_ASSET_MANAGEMENT_DESC:
                "Organizasyon birimlerinizin fiziksel varlıklarını ve ekipmanlarını takip edin ve bakımını yapın. Durumlarını, çalışan yükümlülüklerini, bakım, sigorta ve finansal yaşam döngüsünü izleyin.",
            IDEA_MANAGEMENT_DESC:
                "Üretin, yakalayın, tartışın ve iyileştirin. Değerli içgörü veya alternatif düşünme sürecini organize edin, değerlendirin ve önceliklendirin.",
            PRODUCT_MANAGEMENT_DESC:
                "Alıcıların satın alma kararı vermesine yardımcı olan temel ürün ayrıntılarını yönetin. Ürün özellikleri, açıklamaları, boyutları, fiyatı, ağırlığı, bulunabilirliği, rengi, müşteri yorumları ve daha fazlası.",
            ACCOUNT_MANAGEMENT_DESC:
                "Potansiyel müşterilerinizi ve müşterilerinizi yönetin. Müşterilerin işlerini elde tutun ve bu fırsatları büyütün. Hedeflerine ulaşmalarına yardımcı olun.",
            CONTACT_MANAGEMENT_DESC:
                "Kullanıcılarınızın yönetmekte oldukları hesaplarla ilgili adlar, adresler ve telefon numaraları gibi iletişim bilgilerini kolayca saklamasını ve bulmasını sağlayın. Kişilerle bağlantılı tüm etkinlikleri izleyin.",
            FILE_MANAGER: "Dosya Yöneticisi",
            FILE_MANAGER_DESC:
                "Şirketinizin dijital verilerini yönetin, etkin bir şekilde işbirliği yapın. Aranabilir bir veritabanında organize edilmiş önemli verilerle iş akışını yönetin.",
            PROFILE_MANAGEMENT_DESC:
                "Profilinizi, tercihlerinizi, iletişim bilgilerinizi yönetin. Harcamalarınızı gönderin ve tazminatınızın ve alınan ödemelerin farkında olun.",
            MESSAGES: "Mesajlar",
            MARK_ALL_AS_READ: "Tümünü okundu olarak işaretle",
            MARK_ALL_AS_UNREAD: "Okunmamış olarak işaretle",
            MUTE_MESSAGES: "Mesajları Sessize Al",
            DELETE_MESSAGE: "Mesajı Sil",
            VIEW_ALL: "Hepsini Gör",
            MUTE_NOTIFICATION: "Bildirimi Kapat",
            MUTE_REMINDER: "Hatırlatıcılar Kapat",
            MARK_AS_READ: "Okundu olarak işaretle",
            DELETE_NOTIFICATION: "Bildirimi Sil",
            LAST_LOGGED_IN: "Son giriş:",
            LOCALE_ACCOUNTS: "Kurum içi Hesaplar",
            USER_MANAGEMENT: "Kullanıcı Yönetimi",
            PURCHASE_MANAGEMENT: "Satınalma Yönetimi",
            PURCHASE_MANAGEMENT_DESC:
                "Ürün ve hizmetlerinizin doğru kalitede, doğru miktarda, doğru zamanda, doğru fiyatla ve doğru kaynaktan sağlanması için sürücülerinizi yönetin.",
            REMINDERS: "hatırlatıcılar",
            MARK_AS_READ_UNREAD: "Okundu/Okunmadı olarak işaretle",
            CHANGE_REMINDER: "Hatırlatıcıyı değiştir",
            TEAM_MANAGEMENT: "Takım Yönetimi",
            TEAM_MANAGEMENT_DESC:
                "Ekip üyelerinin görevlerini takip etmelerine ve daha az zaman kaybetmelerine yardımcı olun. İletişimi geliştirin ve bütçeyi etkin bir şekilde yönetin",
            CALENDAR: "Takvim",
            CALENDAR_DESC:
                "Kullanımı kolay, paylaşması basit, özelliklerle dolu takvim uygulamasıyla etkinliklerinizi, hatırlatıcılarınızı, kişisel yapılacakları ve ekip görevlerinizi yönetin",
            ADD_TO_CONTACTS: "Rehbere ekle",
            INTERNAL_ACCOUNTS: "Dahili Hesaplar",
            PROSPECT_ACCOUNTS: "Potansiyeller",
            CUSTOMER_ACCOUNTS: "Müşteri hesapları",
            SEARCHING: "Aranıyor...",
            BIP_BOUNTY_HUNTERS: "BIP - Ödül Avcıları",
            BIP_BOUNTY_HUNTERS_DESC: "Burada sadece gerçek ödül avcıları ödül kazanabiliyor.",
        },

        PROFILE_STATUS: {
            ONLINE: "Çevrimiçi",
            AWAY: "Uzakta",
            IN_A_MEETING: "Toplantıda",
            COMMUTING: "Seyahat Halinde",
            OFFLINE: "Çevrimdışı",
            OUT_OF_OFFICE: "Ofis Dışında",
            DO_NOT_DISTURB: "Meşgul",
        },

        PURCHASE_MANAGEMENT: {
            PURCHASE_INVOICE: "Satınalma Faturası",
            INVOICE_NO: "Fatura No.",
            DOCUMENT_TYPE: "Döküman Tipi",
            PROJECT: "Proje",
            ENTER_PROJECT: "İlişkili Proje",
            DATE_OF_ISSUE: "Veriliş Tarihi",
            EXPIRY_DATE: "Geçerlilik Tarihi",
            INVOICE_AMOUNT: "Fatura Tutarı",
            LOCAL_AMOUNT: "Local Tutar",
            BALANCE: "Balance",
            HEADER_TITLE: "HEADER",
            DETAILS_TITLE: "DETAILS",
            TOTALS_TITLE: "TOPLAMLAR",
            FILE_PHOTOS: "DOSYA/RESİM",
            INVOICE_DETAILS: "FATURA Detayları",
            SELECT_TAGS_NEW: "Etiket Seçiniz",
            NEW_TAG: "Yeni etiket",
            UPLOAD_DOCUMENT: "Döküman Yükleyin",
            ADDRESS: "Adres",
            ENTER_ADDRESS: "Adres Giriniz",
            ORDER_NO: "Sipariş No.",
            ENTER_ORDER_NO: "Sipariş No. Giriniz",
            ORDER_DATE: "Sipariş Tarihi",
            WAYBILL_DETAILS: "İRSALİYE DETAYLARI",
            WAYBILL_NO: "İrsaliye No.",
            ENTER_WAYBILL_NO: "İrsaliye No. Giriniz",
            WAYBILL_DATE: "İrsaliye Tarihi",
            ADD_NEW: "EKLE",
            ENTER_PRODUCT_NAME: "Ürün Adı Giriniz",
            UNIT_PRICE: "Birim Fiyat",
            VAT_RATE: "KDV Oranı",
            TOTAL_VAT_AMOUNT: "Toplam KDV Tutarı",
            TOTAL_EXCLUDING_VAT: "Toplam(KDV Hariç)",
            TOTAL_INCLUDING_VAT: "Toplam(KDV Dahil)",
            ENTER_IN_DOLLAR: "$ Cinsinden Değer",
            ENTER_IN_PERCENTAGE: "% Cinsinden Değer",
            CURRENCY_TOTALS: "Para Birimi Cinsinden Toplamları",
            IN_USD: "(USD Cinsinden)",
            SUBTOTAL: "Ara Toplam",
            LINE_DISCOUNT: "Satır İndirimi",
            GROSS_TOTAL: "Brüt toplam",
            TOTAL_NET_FEE: "Toplam Net Ücret",
            TOTAL_VAT_EIGHT: "Toplam KDV (%8.00)",
            TOTAL_VAT_EIGHTEEN: "Toplam KDV (%18,00)",
            LOCAL_TOTALS: "Yerel Para Birimi Toplamı",
            CURRENT_ACCOUNT: "Cari Hesap",
            ENTER_CURRENT_ACCOUNT: "Cari Hesap Giriniz",
            SERIAL_NO: "Seri No.",
            ENTER_SERIAL_NO: "Seri No. Giriniz",
            PAYMENT_STATUS: "Ödeme Durumu",
            TRACKING_CURRENCY: "Takip Para Birimi",
            SELECT_TRACKING_CURRENCY: "Takip Para Birimi Seçiniz",
            SELECT_CURRENT_ACCOUNT_NAME: "Cari Hesap Seçiniz",
        },

        TERMS_SERVICES: {
            MAKSELLENT_TERMS_OF_SERVICE: "MAKSELLENT HİZMET ŞARTLARI",
            EFFECTIVE_DATE: "YÜRÜRLÜK: 10 Kasım 2021",
            PARAGRAPH_ONE:
                'ÖNEMLİ, DİKKATLİCE OKUYUN: MAKSELLENT VİDEO İLETİŞİM A.Ş. VE İŞTİRAKLERİNİN ("MAKSELLENT") WEB SİTESİNİ VE ÜRÜN VE HİZMETLERİ VE İLGİLİ YAZILIMLARINI (TOPLU OLARAK "HİZMETLER") KULLANIMINIZ VE ERİŞİMİNİZ TAHKİM TALEPLERİNE İLİŞKİN SÖZLEŞMENİZİ DAHİL OLAN BU ŞARTLARI KABUL ETME. LÜTFEN KABUL ETMEDEN ÖNCE MUTLAKA İNCELEYİNİZ.',
            PARAGRAPH_TWO:
                "“KABUL EDİYORUM” BUTONUNA/KUTUSUNA TIKLAYARAK/İŞARET EDEREK, MAKSELLENT WEB SİTESİNE ERİŞEREK VEYA MAKSELLENT HİZMETLERİNİ KULLANARAK, BU HİZMET KOŞULLARININ VE TÜM FUARLARIN, SİPARİŞ FORMLARININ VE “SÖZLEŞME FORMLARININ” (SÖZLEŞME İŞLEMLERİNİN) (SÖZLEŞME) TUS”). MAKSELLENT HİZMETLERİ, BU HİZMET ŞARTLARINA YASAL OLARAK BAĞLI OLMAYAN KİŞİLER İÇİN KULLANILAMAZ.",
            PARAGRAPH_THREE:
                "Maksellent Hizmetleri sağlayacaktır ve siz de bu Sözleşmeye uygun olarak Hizmetlere erişebilir ve bunları kullanabilirsiniz. Maksellent, işbu Sözleşme kapsamındaki Hizmetlerden herhangi birini herhangi bir Bağlı Kuruluşu aracılığıyla sağlayabilir. Hizmetleri çevrimiçi kayıt sayfası veya sipariş formu (her biri “Sipariş Formu”) aracılığıyla sipariş ederseniz, Sipariş Formu, sipariş ettiğiniz Hizmetlerle ilgili ek hüküm ve koşullar ve bilgiler içerebilir. Kullanmayı seçtiğiniz belirli Hizmet için geçerli olan bu tür ek hüküm ve koşullarda aksi açıkça belirtilmedikçe, söz konusu ek koşullar, bu Hizmeti kullanımınız ile ilgili olarak işbu Sözleşmeye dahil edilmiştir.",
            SYSTEM_REQUIREMENTS: "sistem gereksinimleri",
            SYSTEM_REQUIREMENTS_DESCRIPTION:
                "Hizmetlerin kullanımı, bir veya daha fazla uyumlu cihaz, İnternet erişimi (ücrete tabi olabilir) ve belirli yazılımlar (ücrete tabi olabilir) gerektirir ve zaman zaman güncellemeler veya yükseltmeler alınmasını gerektirebilir. Hizmetlerin kullanımı donanım, yazılım ve İnternet erişimini içerdiğinden, Hizmetlere erişme ve bunları kullanma yeteneğiniz bu faktörlerin performansından etkilenebilir. Yüksek hızlı İnternet erişimi önerilir. Zaman zaman değiştirilebilecek bu tür sistem gereksinimlerinin Sizin sorumluluğunuzda olduğunu kabul ve beyan etmektesiniz.",
            DEFINITIONS: "TANIMLAR",
            DEFINITIONS_ONE:
                "Aşağıdaki tanımlar bu Sözleşmede geçerli olacaktır ve tekil için yapılan herhangi bir referans, çoğul olan bir referansı da içerir ve bunun tersi de geçerlidir. Hizmete özel tanımlar, adresinde bulunan Hizmet Açıklamasında bulunur.",
            DEFINITIONS_TW0:
                '"Ortak", bir Tarafla ilgili olarak, o Tarafla doğrudan veya dolaylı olarak kontrol eden, kontrol edilen veya bu Tarafla ortak kontrol altında olan herhangi bir kuruluş anlamına gelir. Bu Anlaşmanın amaçları doğrultusunda, "kontrol", en az yüzde elli (%50) oranında bir ekonomik veya oy hakkı veya bu tür bir ekonomik veya oy hakkı yoksa, yönetimi yönlendirme veya yönlendirmeye neden olma ve yönetimi belirleme gücü anlamına gelir. bu tür kuruluşların politikaları.',
            DEFINITIONS_THREE:
                '"Son Kullanıcı", Hizmetleri kullanan bir Ev Sahibi veya Katılımcı (Hizmet Açıklamasında tanımlandığı gibi) anlamına gelir.',
            DEFINITIONS_FOUR:
                '"İlk Abonelik Süresi", bir Sipariş Formu\'nda belirtildiği gibi bir Hizmet için ilk abonelik süresi anlamına gelir.',
            DEFINITIONS_FIVE:
                '"Hizmet Yürürlük Tarihi", bir Sipariş Formunda belirtildiği şekilde İlk Abonelik Süresinin başladığı tarih anlamına gelir.',
            DEFINITIONS_SIX:
                '"Yenileme Süresi", İlk Abonelik Süresinden veya bir Sipariş Formunda belirtilen başka bir Yenileme Süresinden sonra başlayan bir Hizmet için yenileme abonelik süresi anlamına gelir.',
            DEFINITIONS_SEVEN: "/hizmetler-açıklama.",
            SERVICES: "HİZMETLER",
            SERVICES_DESCRIPTION:
                "Maksellent, Hizmetleri Sipariş Formu'nda açıklandığı şekilde ve dönem boyunca Maksellent tarafından genel kullanıma sunulan Hizmetlere ilişkin standart güncellemeleri sağlayacaktır. Maksellent, kendi takdirine bağlı olarak, önceden haber vermeksizin zaman zaman Hizmetleri durdurabilir veya Hizmetlerin özelliklerini değiştirebilir.",
            BETA_SERVICES: "Beta Hizmetleri",
            BETA_SERVICES_DESCRIPTION:
                "Maksellent, zaman zaman Beta sürümü olarak sınıflandırılan hizmetlere erişim sunabilir. Beta sürümlerine erişim ve bunların kullanımı ek sözleşmelere tabi olabilir. Maksellent, bir Beta sürümünün genel olarak kullanıma sunulacağına dair hiçbir beyanda bulunmaz ve herhangi bir zamanda herhangi bir bildirimde bulunmaksızın bir Beta sürümünü durdurma veya değiştirme hakkını saklı tutar. Beta sürümleri OLDUĞU GİBİ sağlanır, hatalar, hatalar veya diğer kusurlar içerebilir ve bir Beta sürümünü kullanmanıza ilişkin tüm risk Size aittir.",
            USE_OF_SERVICES_AND_YOUR_RESPONSIBILITIES:
                "HİZMETLERİN KULLANIMI VE SORUMLULUKLARINIZ",
            USE_OF_SERVICES_AND_YOUR_RESPONSIBILITIES_DESCRIPTION:
                "Hizmetleri yalnızca bu Sözleşmenin şartlarına uygun olarak kullanabilirsiniz. Sizin ve Son Kullanıcılarınızın Hizmetleri kullanımından yalnızca siz sorumlusunuz ve kayıtla ilgili Yasalar dahil ancak bunlarla sınırlı olmamak üzere, Sizin ve her Son Kullanıcının Hizmetleri kullanımıyla bağlantılı tüm Yasalara uyacak ve bunlara uyulmasını sağlayacaksınız, fikri mülkiyet, gizlilik ve ihracat kontrolü. Hizmetlerin kullanımı yasak olduğu durumlarda geçersizdir.",
            REGISTRATION_INFORMATION: "kayıt Bilgileri",
            REGISTRATION_INFORMATION_DESCRIPTION:
                "Belirli Hizmetlere kaydolmak ve/veya kullanmak için Kendiniz hakkında bilgi vermeniz gerekebilir. Bu tür bilgilerin doğru olacağını kabul edersiniz. Ayrıca bir kullanıcı adı ve şifre seçmeniz istenebilir. Kullanıcı adınızın ve şifrenizin güvenliğini sağlamaktan tamamen siz sorumlusunuz ve bunları herhangi bir üçüncü tarafa ifşa etmemeyi kabul ediyorsunuz.",
            YOUR_CONTENT: "İçeriğiniz",
            YOUR_CONTENT_DESCRIPTION:
                "Sizin tarafınızdan gönderilen veya iletilen veya Hizmetleri kullanırken Sizin tarafınızdan görüntülenen veya yüklenen içerikten (“İçerik”) ve aşağıdakiler dahil ancak bunlarla sınırlı olmamak üzere İçerikle ilgili tüm Kanunlara uyulmasından yalnızca Sizin sorumlu olduğunuzu kabul etmektesiniz. İçeriği kullanmak ve üçüncü taraf haklarına ilişkin uygun bildirimleri sağlamak için üçüncü bir tarafın onayını almanız gerekir. İçeriği Maksellent'a yükleme hakkına sahip olduğunuzu ve bu tür bir kullanımın herhangi bir üçüncü şahsın haklarını ihlal etmediğini beyan ve taahhüt etmektesiniz. Maksellent hiçbir koşulda (a) Hizmetler kullanılırken iletilen veya görüntülenen İçerikten, (b) İçerikteki hatalar veya eksikliklerden veya (c) İçeriğe erişimin, İçeriğin kullanılmasının veya erişimin reddedilmesinin sonucu. Maksellent herhangi bir İçerikten sorumlu olmasa da, Maksellent bu Sözleşmenin herhangi bir hükmünü veya herhangi bir yasayı ihlal ettiğini fark ederse, herhangi bir zamanda Size bildirimde bulunmaksızın herhangi bir İçeriği silebilir. Hizmetlerde veya Hizmetler aracılığıyla gönderdiğiniz, yayınladığınız veya görüntülediğiniz İçerikte halihazırda sahip olduğunuz telif hakkı ve diğer hakları saklı tutarsınız.",
            RECORDINGS: "Kayıtlar",
            RECORDINGS_DESCRIPTION:
                "Tüm kayıt yasalarına uyulmasından siz sorumlusunuz. Toplantı sahibi, Maksellent toplantılarını ve Web Seminerlerini kaydetmeyi seçebilir. Hizmetleri kullanarak, Maksellent'a katıldığınız herhangi bir veya tüm Maksellent toplantıları veya web seminerleri için kayıtları saklama izni veriyorsunuz, eğer bu kayıtlar sistemlerimizde saklanıyorsa. Kayıt etkinleştirildiğinde bir bildirim (görsel veya başka türlü) alacaksınız. Kaydedilmesine izin vermiyorsanız, toplantıdan veya web seminerinden ayrılmayı seçebilirsiniz.",
            PROHIBITED_USE: "Yasak Kullanım",
            PROHIBITED_USE_DESCRIPTION:
                "Hizmetleri şu amaçlarla kullanmayacağınızı ve herhangi bir Son Kullanıcının kullanmasına izin vermeyeceğinizi kabul etmektesiniz: (i) değiştirmek, parçalarına ayırmak, kaynak koda dönüştürmek, türev çalışmalarını hazırlamak, tersine mühendislik yapmak veya başka bir şekilde kaynak koduna erişme girişiminde bulunmak. Hizmetler; (ii) Hizmetleri, Maksellent'in ağlarını, hesaplarınızı veya Hizmetleri kötüye kullanacak, bunlara müdahale edecek veya kesintiye uğratacak şekilde bilerek veya ihmalkar bir şekilde kullanmak; (iii) yasa dışı, hileli, yanlış veya yanıltıcı faaliyetlerde bulunmak, (iv) Hizmetler aracılığıyla üçüncü tarafların fikri mülkiyetini veya diğer haklarını ihlal edebilecek herhangi bir materyali iletmek; (v) rekabetçi bir ürün veya hizmet oluşturmak veya kıyaslama yapmak veya Hizmetlerin herhangi bir özelliğini, işlevini veya grafiğini kopyalamak; veya (vi) taciz edici, iftira niteliğinde, tehdit edici, müstehcen, uygunsuz, herhangi bir tarafın fikri mülkiyet haklarını ihlal edecek veya başka bir şekilde yasa dışı olan, hukuki sorumluluğa yol açabilecek veya veya yürürlükteki herhangi bir yasa veya düzenlemeye göre suç teşkil edebilecek davranışları teşvik eden; (vii) Hizmetlerin performansını herhangi bir şekilde zarar veren, devre dışı bırakan, yok eden veya olumsuz yönde etkileyen veya diğer donanımlara zarar veren veya zarar vermeyi veya diğer donanımlardan bilgi veya veri çekmeyi amaçlayan herhangi bir yazılımı, İçeriği veya kodu yüklemek veya iletmek, Maksellent veya diğer Hizmet kullanıcılarının yazılımları veya ağları; (viii) Hizmetlere veya Hizmetlere veya Hizmetlere veya Maksellent'in güvenlik sistemlerine bağlı herhangi bir sunucuya veya ağa zarar verebilecek, devre dışı bırakabilecek, aşırı yüklenebilecek, bozabilecek veya başka şekilde müdahale edebilecek veya kesintiye uğratabilecek herhangi bir faaliyette bulunmak veya Hizmetleri kullanmak. (ix) Hizmetleri herhangi bir Maksellent politikasını ihlal edecek şekilde veya anti-spam, ihracat denetimi, mahremiyet ve terörle mücadele yasaları ve düzenlemeleri ve ilgili kişilerin rızasını gerektiren yasalar dahil ancak bunlarla sınırlı olmamak üzere yürürlükteki yasaları ihlal edecek şekilde kullanmak. ses ve video kayıtları ve bu tür tüm yasalara ve düzenlemelere uymaktan yalnızca Sizin sorumlu olduğunuzu kabul etmektesiniz.",
            LIMITATIONS_ON_USE: "Kullanım Sınırlamaları",
            LIMITATIONS_ON_USE_DESCRIPTION:
                "Maksellent ile ayrı bir sözleşme kapsamında özellikle izin verilmedikçe, Hizmetleri veya Hizmetler tarafından oluşturulan raporları veya verileri herhangi bir amaçla çoğaltamaz, yeniden satamaz veya dağıtamazsınız. Tarafınızdan satın alınan Hizmetleri üçüncü şahıslara teklif edemez veya kullanmasını sağlayamaz, herhangi bir web sitesinde görüntüleyemez veya Hizmetleri veya bir Hizmetten elde edilen herhangi bir İçeriği (Sizin tarafınızdan oluşturulan İçerik dışında) başka bir şekilde yayınlayamaz veya Hizmetlerden başka bir şekilde gelir elde edemez veya bunları kullanamazsınız. Hizmetlere büyük ölçüde benzeyen bir hizmetin veya ürünün geliştirilmesi, üretimi veya pazarlanması için Hizmetler.",
            RESPONSIBILITY_FOR_END_USERS: "SON KULLANICILAR İÇİN SORUMLULUK",
            RESPONSIBILITY_FOR_END_USERS_ONE:
                "Hesabınız aracılığıyla Hizmetlere erişen veya Hizmetleri kullanan tüm Son Kullanıcıların faaliyetlerinden siz sorumlusunuz ve bu tür Son Kullanıcıların bu Sözleşmenin şartlarına ve herhangi bir Maksellent politikasına uymasını sağlamayı kabul etmektesiniz. Maksellent, ihlaller için hiçbir sorumluluk veya yükümlülük kabul etmez. Hizmetlerin herhangi bir kişi tarafından kullanımıyla bağlantılı olarak bu Sözleşmenin herhangi bir ihlalinden haberdar olursanız, lütfen şu adresten Maksellent ile iletişime geçin:",
            RESPONSIBILITY_FOR_END_USERS_TWO:
                "Maksellent, dikkatine gelen her türlü şikayet ve ihlali araştırabilir ve uyarıların yapılması, içeriğin kaldırılması veya hesapların ve/veya Kullanıcı profillerinin feshedilmesi dahil ancak bunlarla sınırlı olmamak üzere, uygun olduğuna inandığı her türlü (veya hiçbir) eylemi gerçekleştiremez. Maksellent, Hizmetlerin kullanımı sırasında görüntülenen herhangi bir veri veya diğer içerikten, bunlarla sınırlı olmamak kaydıyla, bu tür verilerdeki veya içeriklerdeki herhangi bir hata veya eksiklik veya herhangi bir kayıp veya hasar dahil olmak üzere hiçbir koşulda sorumlu olmayacaktır. herhangi bir veri veya içeriğin kullanılmasının, bunlara erişimin veya erişimin reddedilmesinin bir sonucu.",
            MAKSELLENT_OBLIGATIONS_FOR_CONTENT:
                "İÇERİK İÇİN MAKSELLENT YÜKÜMLÜLÜKLERİ",
            MAKSELLENT_OBLIGATIONS_FOR_CONTENT_DESCRIPTION:
                "Maksellent, endüstri standartlarına uygun olarak İçeriğin yetkisiz ifşasını veya İçeriğe erişimi önlemek için makul fiziksel ve teknik korumaları sürdürecektir. Maksellent, İçeriğe yetkisiz erişimin farkına varması durumunda Sizi bilgilendirecektir. Maksellent, (a) bu Sözleşmede ve Maksellent'in Gizlilik Bildiriminde belirtilenler dışında; (b) Sizin tarafınızdan yetkilendirildiği veya talimat verildiği şekilde, (c) bu Sözleşme kapsamındaki yükümlülüklerini yerine getirmesi gerektiği şekilde; veya (d) Yasanın gerektirdiği şekilde. Maksellent'in İçerikle ilgili başka hiçbir yükümlülüğü yoktur.",
            ELIGIBILITY: "UYGUNLUK",
            ELIGIBILITY_DESCRIPTION:
                "En az 16 yaşında olduğunuzu ve bu Sözleşmede belirtilen şartlar, koşullar, yükümlülükler, beyanlar, beyanlar ve garantileri yerine getirmek ve bu Sözleşmeye uymak ve uymak için tam olarak yetkin ve yetkin olduğunuzu kabul edersiniz. 16 yaşın altında olduğunuzu veya başka bir şekilde uygun olmadığınızı düşünürsek, erişiminiz uyarı yapılmaksızın sonlandırılabilir.",
            INTENDED_USE_RESTRICTION_ON_USE_BY_CHILDREN:
                "KULLANIM AMACI; ÇOCUKLARIN KULLANIMINA İLİŞKİN KISITLAMA",
            INTENDED_USE_RESTRICTION_ON_USE_BY_CHILDREN_DESCRIPTION:
                "Hizmetler, iş amaçlı kullanıma yöneliktir. Hizmetleri, bu Sözleşmenin hüküm ve sınırlamalarına tabi olarak başka amaçlar için kullanmayı seçebilirsiniz. Maksellent, Eğitim için Maksellent'ı (K-12) kullanan bir Okul Abonesi (bu terimin Hizmet Açıklamasında tanımlandığı gibi) aracılığıyla olmadıkça, 16 yaşından küçük kişiler tarafından kullanılmak üzere tasarlanmamıştır.",
            CHARGES_AND_CANCELLATION: "ÜCRETLER VE İPTAL",
            CHARGES_AND_CANCELLATION_DESCRIPTION:
                "Maksellent'in, Kredi kartınızdan veya Sizin tarafınızdan seçilen ve Maksellent tarafından onaylanan diğer ödeme mekanizmalarından (“Hesabınız”), vergiler ve hizmet ücretleri, kurulum ücretleri, abonelik ücretleri veya Hesabınızla ilişkili diğer herhangi bir ücret veya ücret. Aksi belirtilmediği sürece, Maksellent tarafından gösterilen tüm fiyatlar ve ücretler, vergiler ve yasal ücretler, hizmet, hizmet ücretleri, kurulum ücretleri, abonelik ücretleri veya Hesabınızla ilişkili diğer herhangi bir ücret veya ücrete dahil değildir. Maksellent tarafından yerel kanun ve yönetmeliklere uygun olarak düzenlenen faturalarda, geçerli olduğu durumlarda vergiler ve yasal ücretler tahsil edilecektir. Alınan vergiler ve yasal ücretler önceden bildirilmeksizin değiştirilebilir. Tarafınızdan bu Sözleşme kapsamında tarafımıza yapılan tüm ödemeler, yasaların gerektirdiği şekilde ücretsiz ve herhangi bir kesinti veya stopajdan arındırılacaktır. Herhangi bir ödemede bu tür bir kesinti veya stopaj (yurt içi veya sınır ötesi stopaj vergileri dahil ancak bunlarla sınırlı olmamak üzere) gerekiyorsa, tarafımızca alınan net tutarın ödenmesi gereken tutara eşit olması için gerekli olan ek tutarları ödeyeceksiniz. ve bu Sözleşme kapsamında ödenebilir. Bu Anlaşma kapsamında yapılan ödemelerle ilgili olarak vergiler için herhangi bir stopaj veya kesinti miktarını azaltmak veya ortadan kaldırmak için makul olarak talep edilen vergi formlarını size sağlayacağız. Maksellent, ücretsiz bir hizmetten ücretli bir hizmete geçmek ve daha önce ücretsiz olarak sunulan Hizmetler için ücret almak dahil olmak üzere, fiyatları herhangi bir zamanda değiştirebilir; ancak, Maksellent'ın abone olduğunuz bir Hizmetin fiyatını değiştirmesi durumunda, Maksellent size önceden bildirimde bulunacak ve Hesabınızı feshetme fırsatı sunacaktır ve ilgili ücretleri ve bu ücretleri ödemeyi kabul etti. Maksellent'ın, Hizmetler için Maksellent'a borçlu olunan ücretleri Hesabınız aracılığıyla tahsil edememesi durumunda, Maksellent'ın bu ücretleri Sizden tahsil etmek için gerekli gördüğü diğer adımları atabileceğini ve yapılan tüm masraf ve harcamalardan Sizin sorumlu olacağınızı kabul etmektesiniz. Maksellent tarafından tahsilat ücretleri, mahkeme masrafları ve avukatlık ücretleri dahil olmak üzere bu tür tahsilat faaliyetleriyle bağlantılı olarak. Ayrıca Maksellent'in vadesinde ödenmeyen tutarlar için ayda %1,5'ten daha az veya yasaların izin verdiği en yüksek tutarda faiz tahsil edebileceğini kabul etmektesiniz. Aboneliğinizi istediğiniz zaman iptal edebilirsiniz. İptal ederseniz, herhangi bir ek hizmet koşulu için faturalandırılmazsınız ve hizmet, mevcut Abonelik Süresinin sonuna kadar devam eder. İptal ederseniz, ödemesi yapılmış hiçbir hizmet için geri ödeme alamazsınız.",
            TERMINATION: "SONLANDIRMA",
            TERMINATION_DESCRIPTION:
                "Maksellent web sitesi, Hesabınızı nasıl sonlandıracağınıza ilişkin bilgiler içerir. Belirli bir süre için bir Hizmet satın aldıysanız, söz konusu fesih, o sırada geçerli olan dönemin son gününde geçerli olacaktır. Sipariş Formunuz, taraflardan herhangi biri bir sonraki Yenileme Süresinin başlangıcından en az otuz (30) gün önce fesih bildiriminde bulunmadıkça, Yenileme Süresinin otomatik olarak başlamasını sağlayabilir. Bu Sözleşmenin herhangi bir hükmüne uymazsanız, Maksellent bu Sözleşmeyi derhal feshedebilir ve Sizin tarafınızdan daha önce ödenen ücretleri alıkoyabilir. 1 ve 3'ten 20'ye kadar olan bölümler, bu Sözleşmenin herhangi bir şekilde feshedilmesinden sonra da geçerliliğini koruyacaktır. Bu Sözleşmenin herhangi bir şekilde feshedilmesi üzerine, Hizmetlerin herhangi bir şekilde kullanımına son vermelisiniz. Herhangi bir zamanda Hizmetlerden memnun kalmazsanız, tek çareniz Hizmetleri kullanmayı bırakmak ve bu fesih sürecini takip etmektir.",
            PROPRIETARY_RIGHTS: "MÜLKİYET HAKLARI",
            PROPRIETARY_RIGHTS_DESCRIPTION:
                'Maksellent ve/veya tedarikçileri, uygun olduğu şekilde, Hizmetlerdeki ve Hizmetlerle ilişkili veya gösterilen tüm ticari adlar, ticari markalar, hizmet markaları, logolar ve alan adlarındaki ("Maksellent Markaları") tüm mülkiyet haklarının mülkiyetini elinde tutar. Maksellent\'in herhangi bir Maksellent Markasını veya diğer özel bilgilerini (resimler, metin, sayfa düzeni veya form dahil) dahil etmek için açık yazılı izin olmadan çerçeveleyemez veya çerçeveleme tekniklerini kullanamazsınız. Maksellent\'in açık yazılı izni olmaksızın, Maksellent Markalarını kullanan meta etiketleri veya diğer "gizli metinleri" kullanamazsınız.',
            COPYRIGHT: "TELİF HAKKI",
            COPYRIGHT_DESCRIPTION:
                "Bu tür mülkiyet haklarının sahibinin önceden yazılı onayını almadan telif hakkıyla korunan materyalleri, ticari markaları, tanıtım haklarını veya diğer mülkiyet haklarını yayınlayamaz, değiştiremez, dağıtamaz veya çoğaltamazsınız. Maksellent, başka bir tarafın telif haklarını ihlal ettiği iddia edilen herhangi bir Kullanıcının Hizmetlere erişimini engelleyebilir. Yukarıdakileri sınırlamaksızın, telif hakkınızın ihlal edildiğini düşünüyorsanız, lütfen burada belirtildiği şekilde Maksellent'ı bilgilendirin.",
            EXPORT_RESTRICTIONS: "İHRACAT KISITLAMALARI",
            EXPORT_RESTRICTIONS_DESCRIPTION:
                "Hizmetlerin veya bir kısmının İhracat İdaresi Düzenlemeleri, 15 C.F.R.'ye tabi olduğunu kabul etmektesiniz. Bölüm 730-774, Amerika Birleşik Devletleri'ne aittir ve diğer geçerli ülke ihracat kontrolü ve ticari yaptırım yasalarına (\"İhracat Denetimi ve Yaptırım Yasaları\") tabi olabilir. Maksellent, talep üzerine Hizmetleri için geçerli olan ABD ihracat sınıflandırmasını/sınıflarını sağlayacaktır. Siz ve Son Kullanıcılarınız, İhracat Kontrol ve Yaptırım Kanunlarını ihlal ederek, Hizmetlerin herhangi bir kısmına veya ilgili teknik bilgi veya materyallere doğrudan veya dolaylı olarak erişemez, bunları kullanamaz, ihraç edemez, yeniden ihraç edemez, yönlendiremez, aktaramaz veya ifşa edemez. Şunları beyan ve garanti edersiniz: (i) Siz ve Son Kullanıcılarınız (a) ABD ticari yaptırımlarına veya diğer önemli ticaret kısıtlamalarına (Küba, İran, Kuzey Kore, Suriye ve Ukrayna'nın Kırım bölgesi) ve Sizin ve Son Kullanıcılarınızın Hizmetlere erişmeyeceğinizi veya bunları kullanmayacağınızı veya Hizmetleri bu tür ülke veya bölgelerde ihraç etmeyeceğinizi, yeniden ihraç etmeyeceğinizi, yönlendirmeyeceğinizi veya devretmeyeceğinizi; (b) ABD Hazine Bakanlığı'nın Özel Olarak Belirlenmiş Vatandaşlar ve Engellenmiş Kişiler Listesi veya Yabancı Yaptırım Kaçakçıları Listelerinde tanımlanan kişiler veya bireysel veya toplu olarak kişilerin %50 veya daha fazlasına sahip olunmaması; ve (c) ABD Ticaret Bakanlığı'nın Reddedilen Kişiler Listesi, Kuruluş Listesi veya Doğrulanmamış Listesi ya da ABD Dışişleri Bakanlığı'nın yayılmayla ilgili listelerinde yer alan kişiler değiller; (ii) Siz ve Çin, Rusya veya Venezuela'da bulunan Son Kullanıcılarınız, Askeri Son Kullanıcılar değilsiniz ve Maksellent'in Hizmetlerini 15 C.F.R. 744.21; (iii) Siz veya Son Kullanıcılarınız tarafından oluşturulan veya gönderilen hiçbir İçerik, İhracat Kontrol ve Yaptırım Kanunları kapsamında ifşa, aktarım, indirme, ihracat veya yeniden ihracatla ilgili herhangi bir kısıtlamaya tabi değildir; ve (iv) Siz ve Son Kullanıcılarınız, ABD Ticaret Bakanlığı veya ABD Hazine Bakanlığı tarafından yönetilen ABD antiboykot yasalarının ihlalini teşkil edecek veya bu yasalar uyarınca cezalandırılacak herhangi bir işlem yapmayacaksınız. İhracat Kontrol ve Yaptırımlar Yasalarına uymaktan ve bunları herhangi bir değişiklik için izlemekten yalnızca siz sorumlusunuz.",
            NO_HIGH_RISK_USE: "YÜKSEK RİSKLİ KULLANIM YOK",
            NO_HIGH_RISK_USE_DESCRIPTION:
                "Hizmetler, nükleer tesislerin işletilmesi, uçak navigasyon/iletişim sistemleri, hava trafik kontrolü ve yaşam destek veya silah sistemleri dahil ancak bunlarla sınırlı olmamak üzere, arıza emniyetli kontroller gerektiren tehlikeli ortamlarda kullanım için tasarlanmamıştır veya lisanslanmamıştır. Hizmetler, herhangi bir YÜKSEK RİSKLİ ortamda veya için kullanılmayacaktır.",
            INJUNCTIVE_RELIEF: "İHTİYATİ TEDBİR",
            INJUNCTIVE_RELIEF_DESCRIPTION:
                'Hizmetlerin bu Sözleşmeye aykırı herhangi bir şekilde kullanılmasının veya Hizmetlerle ilgili teknik bilgi veya materyallerin herhangi bir şekilde aktarılması, alt lisanslanması, kopyalanması veya ifşa edilmesinin Maksellent, İştirakleri, tedarikçileri ve Maksellent tarafından yetkilendirilen diğer taraflarda onarılamaz zararlara yol açabileceğini kabul etmektesiniz. Hizmetleri yeniden satmak, dağıtmak veya tanıtmak için ("Bayiler") ve bu koşullar altında Maksellent, Bağlı Kuruluşları, tedarikçileri ve Satıcıları, ön ve kalıcı ihtiyati tedbir.',
            NO_WARRANTIES: "GARANTİ YOK",
            NO_WARRANTIES_DESCRIPTION:
                "HİZMETLERİN “OLDUĞU GİBİ” SUNULDUĞUNU VE MAKSELLENT, İŞTİRAKLERİ, TEDARİKÇİLERİ VE SATICILARININ, HERHANGİ BİR SINIRLAMASIZ VEYA HİÇBİR SINIRLAMA OLMAKSIZIN, AÇIK VEYA ZIMNİ HER TÜRLÜ GARANTİYİ AÇIKÇA REDDEDERLER VE KABUL EDERSİNİZ. İHLAL MAKSELLENT, BAĞLI ŞİRKETLERİ, TEDARİKÇİLERİ VE SATICILARI, WIREMENT HİZMETLERİNDEN ELDE EDİLEN HERHANGİ BİR BİLGİNİN DOĞRULUĞU VEYA GÜVENİLİRLİĞİ HAKKINDA, HİZMETLERİN KULLANIMINDAN ELDE EDİLECEK SONUÇLARA İLİŞKİN HİÇBİR GARANTİ VEYA BEYAN VERMEZ. KESİNTİSİZ, ZAMANINDA, GÜVENLİ VEYA HATASIZ OLUN. HİZMETLERİN KULLANIMININ RİSKİ TAMAMEN SİZE AİTTİR. HİZMETLERİN KULLANIMI ARACILIĞIYLA İNDİRİLEN VEYA BAŞKA BİR ŞEKİLDE ELDE EDİLEN HER TÜRLÜ MATERYAL VE/VEYA VERİLER KENDİ TAKDİRİMİNİZE VE RİSKİNİZE AİTTİR. HİZMETLERİN KULLANIMINDAN KAYNAKLANAN HERHANGİ BİR ZARARDAN YALNIZCA SİZ SORUMLU OLACAKSINIZ. HİZMETLERİN KULLANIMINDAN VEYA PERFORMANSINDAN KAYNAKLANAN TÜM RİSKLER SİZE AİTTİR. MAKSELLENT, KULLANICI BİLGİLERİNİN VEYA KULLANICILAR ARASINDAKİ İLETİŞİMİN SAKLANMASINA İLİŞKİN HİÇBİR SORUMLULUK KABUL ETMEZ. MAKSELLENT, HİZMETLERİN KULLANIMINDAN KAYNAKLANAN ÖZEL SONUÇLARI GARANTİ VERMEZ VE ÖDÜN VERMEZ. KULLANIM RİSKİ KENDİ RİSKİNİZE AİTTİR.",
            INDEMNIFICATION: "TAZMİNAT",
            INDEMNIFICATION_DESCRIPTION:
                "Maksellent'ı, bağlı kuruluşlarını, memurlarını, yöneticilerini, çalışanlarını, danışmanlarını, acentelerini, tedarikçilerini ve Satıcılarını her türlü üçüncü şahıs iddialarından, sorumluluğundan, zararlarından ve/veya maliyetlerinden (bunlarla sınırlı olmamak üzere, Hizmetleri kullanımınızdan, bu Sözleşmeyi ihlal etmenizden veya Sizin veya Hesabınızın diğer herhangi bir kullanıcısı tarafından, herhangi bir kişi veya kuruluşun herhangi bir fikri mülkiyet hakkının veya diğer haklarının veya geçerli yasanın ihlalinden kaynaklanan avukatlık ücretleri).",
            LIMITATION_OF_LIABILITY: "SORUMLULUĞUN SINIRLANDIRILMASI",
            LIMITATION_OF_LIABILITY_DESCRIPTIONN:
                "GEÇERLİ YASALARIN İZİN VERDİĞİ AZAMİ ÖLÇÜDE, MAKSELLENT VEYA İŞTİRAKLERİ, TEDARİKÇİLERİ VEYA SATICILARI HİÇBİR DURUMDA, PROFESYONEL DAHİL OLARAK, İŞLEMLERDEN OLUŞAN HERHANGİ BİR ÖZEL, ARIZİ, DOLAYLI, ÖRNEK VEYA NİHAİ HASARDAN SORUMLU TUTULAMAZ. HİZMETLERİN KULLANILMAMASI VEYA KULLANILAMAMASI VEYA TEKNİK VEYA BAŞKA DESTEK HİZMETLERİNİN SAĞLANMAMASI VEYA BAŞARISIZLIĞINDAN KAYNAKLANAN KESİNTİ, İŞ BİLGİSİ KAYBI VEYA DİĞER HERHANGİ BİR MADENİ KAYIP VEYA ZARAR, VEYA HERHANGİ BİR YASAL TEORİ, MAKSELLENT, İŞTİRAKLERİ, TEDARİKÇİLERİ VEYA SATICILARI BU TÜR ZARARLARIN OLASILIĞI HAKKINDA BİLGİLENDİRİLMİŞ OLSA DAHİ. HERHANGİ BİR DURUMDA, MAKSELLENT'İN, İŞTİRAKLERİ'NİN, TEDARİKÇİLERİNİN VE SATICILARININ MAKSİMUM KÜMÜLATİ SORUMLULUĞU VE BU SÖZLEŞMEDEN KAYNAKLANAN VEYA BU SÖZLEŞMEYLE İLGİLİ TÜM İDDİALAR İÇİN SİZİN MÜNHASIR ÇÖZÜM YOLUYLA SINIRLI OLACAKTIR. BU TÜR İDDİALARA YÖNELİK OLAY VEYA DURUMLARDAN ÖNCEKİ ON İKİ (12) AY İÇİNDE. Bazı eyaletler ve yargı bölgeleri sorumluluğun hariç tutulmasına veya sınırlandırılmasına izin vermediğinden, yukarıdaki sınırlama Sizin için geçerli olmayabilir.",
            AGREEMENT_TO_ARBITRATE_WAIVER_OF_CLASS_ACTION:
                "TAHKİM SÖZLEŞMESİ; TOPLU DAVADAN FERAGAT",
            AGREEMENT_TO_ARBITRATE_WAIVER_OF_CLASS_ACTION_DESCRIPTION:
                "Amerika Birleşik Devletleri'nde ikamet ediyorsanız, anlaşmazlıkları Ek A'nın hükümleri uyarınca tahkim yoluyla yalnızca bireysel olarak çözmeyi kabul edersiniz. Taraflar, toplu veya toplu olarak herhangi bir dava, dava veya dava açma hakkından açıkça feragat eder. herhangi bir tarafın temsili sıfatıyla hareket ettiği veya hareket etmeyi önerdiği dava, özel başsavcılık davası veya diğer herhangi bir dava.",
            PRIVACY_AND_OTHER_POLICIES: "GİZLİLİK VE DİĞER POLİTİKALAR",
            PRIVACY_AND_OTHER_POLICIES_ONE:
                "Hizmetlerin kullanımı, aynı zamanda, Maksellent'in web sitesinin alt kısmındaki \"Gizlilik ve Yasal Politikalar\" seçilerek bir bağlantı bulunabilecek olan Maksellent'in Gizlilik Bildirimine tabidir. Gizlilik Bildirimi ve fark edilen tüm politikalar,",
            PRIVACY_AND_OTHER_POLICIES_TWO:
                "bu Sözleşmeye bu referansla dahil edilmiştir. Ayrıca, Hizmetleri Kullanımınız Maksellent'ın herhangi bir kişisel olarak tanımlanabilir bilgiyi (“PII” veya “Kişisel Veri”) işlemesini gerektiriyorsa, Maksellent bunu her zaman Maksellent Global Veri İşleme Ekimize uygun olarak yapacaktır.",
            PRIVACY_AND_OTHER_POLICIES_THREE:
                "bu Hizmet Koşullarına dahil edilmiştir. Ek olarak, Maksellent'in, Pazarlama iletişimlerini veya bildirimlerini almayı seçip seçmediğinize bakılmaksızın, Hizmetleri kullanımınızla ilgili bilgilerle e-posta veya başka bir şekilde Sizinle iletişime geçebileceğini anlıyor ve kabul ediyorsunuz.",
            MISCELLANEOUS: "ÇEŞİTLİ",
            CHOICE_OF_LAW_AND_FORUM: "Hukuk ve Forum Seçimi",
            CHOICE_OF_LAW_AND_FORUM_DESCRIPTION:
                "Bu Sözleşme, Kaliforniya'da Kaliforniya sakinleri tarafından yapılan ve Kaliforniya'da gerçekleştirilecek olan anlaşmalara uygulandığı şekilde, ABD Kaliforniya Eyaleti yasalarına tabi olacak ve bu yasalara göre yorumlanacaktır. Ek A'da belirtilenler dışında, Taraflar, Santa Clara County, California'da bulunan ve onlara hizmet eden eyalet mahkemelerinin ve California'nın Kuzey Bölgesindeki federal mahkemelerin münhasır yargı yetkisini ve yerini kabul eder.",
            CONTRACTING_ENTITY: "İdare",
            CONTRACTING_ENTITY_DESCRIPTION:
                "Maksellent hesabınızın Hindistan'da bir adrese/adrese satılmış bir fatura yansıtması durumunda, bu HŞ kapsamındaki sözleşme kuruluşu Maksellent'in Bağlı Kuruluşu, ZVC India Pvt olacaktır. Ltd.",
            WAIVER_AND_SEVERABILITY: "Feragat ve Bölünebilirlik",
            WAIVER_AND_SEVERABILITY_DESCRIPTION:
                "Taraflardan herhangi birinin bu Sözleşme kapsamındaki haklarından herhangi birini kullanmaması veya bu Sözleşmenin herhangi bir hükmünü uygulamaması, bu tür haklardan feragat ettiği veya bu haklardan feragat ettiği veya bu hükmü uygulama kabiliyeti olarak kabul edilmeyecektir. Bu Sözleşmenin herhangi bir hükmünün yetkili bir mahkeme tarafından yasa dışı, geçersiz veya uygulanamaz olduğuna karar verilirse, bu hüküm, orijinal hükümle mümkün olduğunca aynı ekonomik etkiyi elde etmek için değiştirilecek ve bu Sözleşmenin geri kalanı yürürlükte kalacaktır. tam güç ve etki.",
            GENERAL_PROVISIONS: "Genel Hükümler",
            GENERAL_PROVISIONS_DESCRIPTION:
                "Bu Sözleşme, Taraflar arasında işbu Sözleşmenin konusuna ilişkin tüm mutabakatı ve anlaşmayı kapsar ve Siz veya Şirketiniz ayrı bir yazılı sözleşme akdetmiş olmanız veya sizin tarafınızdan ayrı bir yazılı sözleşme akdetmiş olmanız veya sizin tarafınızdan yapılmış olması hariç olmak üzere, Taraflar arasında bu konuyla ilgili olarak daha önce yapılmış tüm mutabakat ve anlaşmaların yerine geçer. Hizmetleri kullanımınızı düzenleyen ayrı bir sözleşmeye atıfta bulunan bir sipariş formu imzaladıysanız, bu Sözleşme, bu Sözleşmenin herhangi bir hükmünün söz konusu sözleşmenin şartlarıyla çeliştiği ölçüde geçerli olacaktır. Maksellent, kendi takdirine bağlı olarak zaman zaman bu Sözleşmenin şartlarını değiştirmeyi veya tamamlamayı seçebilir. Maksellent, bu Sözleşmedeki herhangi bir önemli değişikliği Size bildirmek için ticari olarak makul ticari çabayı gösterecektir. Bu Sözleşmede yapılan değişikliklerin yayınlanmasından sonraki on (10) iş günü içinde (veya varsa, bildirim tarihinden itibaren on (10) iş günü), bunlar Sizin için bağlayıcı olacaktır. Değişiklikleri kabul etmiyorsanız, Hizmetleri kullanmayı bırakmalısınız. Bu on iş günü sonrasında Hizmetleri kullanmaya devam ederseniz, bu Sözleşmenin koşullarındaki değişiklikleri kabul etmiş sayılacaksınız. Belirli Hizmetlere katılmak için, yazılım indirmeniz ve/veya ek hüküm ve koşulları kabul etmeniz gerektiği size bildirilebilir. Bu tür ek hüküm ve koşullarda açıkça belirtilmediği sürece, bu ek koşullar işbu Sözleşmeye dahil edilmiştir. Bu Sözleşme İngilizce dilinde hazırlanmıştır ve bu tür sürüm her açıdan kontrol edici olacaktır ve bu Sözleşmenin İngilizce olmayan herhangi bir sürümü yalnızca konaklama amaçlıdır.",
            Exhibit_A: "sergi A",
            BINDING_ARBITRATION: "bağlayıcı Tahkim",
            BINDING_ARBITRATION_DESCRIPTION:
                "Hizmet Şartlarına ilişkin bu Ek A, Bağlayıcı Tahkim ve Toplu Dava Feragati için geçerli olan diğer hükümleri açıklamaktadır.",
            DISPUTES: "anlaşmazlıklar",
            DISPUTES_DESCRIPTION:
                "Anlaşmazlık, Hizmetler, Hizmetlerle ilgili herhangi bir yazılım, Hizmetlerin fiyatı, Hesabınız, Maksellent'in reklamları, pazarlaması veya iletişimleri, satın alma işleminiz veya faturalandırmanız veya bu Sözleşmenin herhangi bir şartı ile ilgili olarak Siz ve Maksellent arasındaki herhangi bir ihtilaftır. Sizin veya Maksellent'ın fikri mülkiyet haklarının uygulanması veya geçerliliği ile ilgili anlaşmazlıklar hariç, sözleşme, garanti, haksız fiil, tüzük veya düzenleme dahil olmak üzere herhangi bir yasal teori kapsamında. Anlaşmazlıkları çözmek için en iyi çaba sürecinin bir parçası olarak ve tahkim işlemlerini başlatmadan önce, her bir taraf, anlaşmazlığın tanımı, sorunu çözmek için ne gibi çabalar gösterildiği ve nelerin yapıldığı da dahil olmak üzere anlaşmazlığı diğer tarafa bildirmeyi kabul eder. ihtilaflı taraf çözüm olarak talep ediyor,",
            SMALL_CLAIMS_COURT_AVAILABLE: "Küçük Alacaklar Mahkemesi Mevcuttur",
            SMALL_CLAIMS_COURT_AVAILABLE_DESCRIPTION:
                "Mahkemenin gereksinimlerini karşılıyorsanız, yerel Küçük Alacaklar Mahkemesinde dava açabilirsiniz. Ancak, bu tür bir iddianın devredilmesi, kaldırılması veya başka bir mahkemeye temyiz edilmesi halinde Maksellent'in tahkim talep etme hakkı saklıdır.",
            ARVITRAYION_PROCEDURE: "Tahkim Prosedürü",
            ARVITRAYION_PROCEDURE_DESCRIPTION:
                "Bölüm A veya B uyarınca çözülmeyen anlaşmazlıklar tahkim yoluyla çözülecektir. Amerikan Tahkim Derneği (“AAA”), herhangi bir tahkimi Ticari Tahkim Kuralları kapsamında yürütecektir. Daha fazla bilgi için bkz. adr.org. Tahkim duruşmaları, birincil iş yerinizin federal yargı bölgesinde yapılacaktır. Tek hakem atanacak. Hakem: (a) geçerli tüm maddi Hukuka uymalı; (b) geçerli sınırlamalara uymak; (c) geçerli imtiyaz taleplerine saygı göstermek; (d) kararın gerekçelerini de içeren yazılı bir karar verir. Hakem tazminat, tespit veya ihtiyati tedbir ve masraflara (makul avukatlık ücretleri dahil) hükmedebilir. Herhangi bir tahkim kararı, yargı yetkisine sahip herhangi bir mahkemede (bir karar yoluyla) uygulanabilir. AAA Kuralları uyarınca, hakem, herhangi bir talebin tahkime elverişliliği de dahil olmak üzere kendi yargı yetkisine karar verir; ancak, bir mahkeme, tahkim yasağını sınıf çapında veya temsili sıfatıyla uygulama konusunda münhasır yetkiye sahiptir.",
            ARBITRATION_FEES: "Tahkim Ücretleri",
            ARBITRATION_FEES_DESCRIPTION:
                "Tahkim masraflarını karşılayamıyorsanız, Maksellent bu masrafları, hakemin kararına bağlı olarak, Maksellent'in haklı çıkması durumunda masrafların Maksellent'e ödenmesi gerekip gerekmediğine bağlı olarak, size avans edecektir. 75.000 ABD Dolarını aşan anlaşmazlıklar için, dosyalama ücretlerinin ve AAA'nın ve hakemin ücret ve giderlerinin ödenmesi AAA kurallarına tabi olacaktır.",
            CONFLICT_WITH_AAA_RULES: "AAA Kuralları ile Çatışma",
            CONFLICT_WITH_AAA_RULES_DESCRIPTION:
                "Bu Sözleşme, AAA'nın Ticari Tahkim Kuralları ile bir ihtilaf olması durumunda geçerlidir.",
            REQUIREMENT_TO_FILE_WITHIN_ONE_YEAR:
                "Bir Yıl İçinde Dosyalama Zorunluluğu",
            REQUIREMENT_TO_FILE_WITHIN_ONE_YEAR_DESCRIPTION:
                "Diğer herhangi bir sınırlama statüsüne bakılmaksızın, bu Sözleşme kapsamındaki bir hak talebi veya anlaşmazlık, ilk açılabileceği tarihten itibaren bir yıl içinde Küçük Alacaklar Mahkemesine sunulmalı veya tahkim için fark edilmelidir, aksi takdirde bu tür talep kalıcı olarak engellenecektir.",
            SEVERABILITY: "Bölünebilirlik",
            SEVERABILITY_DESCRIPTION:
                "Toplu davadan feragatin bir anlaşmazlığın tamamı veya bir kısmıyla ilgili olarak yasa dışı veya uygulanamaz olduğu tespit edilirse, bu kısımlar tahkime götürülmeyecek, ancak kalan kısım tahkim yoluyla çözülecek şekilde mahkemede çözülecektir. Bu Ek A'nın herhangi bir hükmünün yasa dışı veya uygulanamaz olduğu tespit edilirse, o hüküm kesilecektir; ancak, kalan hükümler yine de geçerli olacak ve ayrılmış hüküm dahil olmak üzere bu Ek'in orijinal amacına mümkün olduğunca yakın bir şekilde yorumlanacaktır.",
        },

        PRIVACY_POLICY: {
            MAKSELLENT_PRIVACY_STATEMENT: "Maksellent Gizlilik Bildirimi",
            LAST_UPDATE_DATE: "Son güncelleme: 1 Kasım 2021",
            PARAGRAPH:
                "Bu Gizlilik Bildirimi, doğrudan Maksellent Video Communications, Inc. (“Maksellent”) tarafından sunulan ürün ve hizmetleri sağlamak için topladığımız ve/veya işlediğimiz (toplama, düzenleme, yapılandırma, depolama, kullanma veya ifşa etme dahil) kişisel verileri açıklamaktadır. Maksellent'in web siteleri ve toplantıları, web seminerleri ve mesajlaşma platformu ve Maksellent App Marketplace (“Maksellent Ürünleri” veya “Ürünler”) dahil. Maksellent Ürünleri, Maksellent tarafından geliştirilen ve ayrı bir gizlilik politikası (burada listelenmiştir) kapsamındaki ürünleri içermez.",
            WHAT_PERSONAL_DATA_DO_WE_RECEIVE:
                "Hangi Kişisel Verileri Alıyoruz?",
            HOW_DO_WE_USE_PERSONAL_DATA: "Kişisel Verileri Nasıl Kullanıyoruz?",
            HOW_DO_WE_SHARE_PERSONAL_DATA: "Kişisel Verileri Nasıl Paylaşırız?",
            WHO_CAN_SEE_AND_SHARE_MY_PERSONAL_DATA_WHEN_I_USE_MAKSELLENT:
                "Maksellent Kullandığımda Kişisel Verilerimi Kimler Görebilir ve Paylaşabilir?",
            PRIVACY_RIGHT_AND_CHOICES: "Gizlilik Hakları ve Seçimleri",
            CHILDREN: "Çocuklar",
            HOW_TO_CONTACT_US: "Bizimle nasıl iletişime geçilir",
            RETENTION: "Tutulma",
            EUROPEAN_DATA_PROTECTION_SPECIFIC_INFORMATION:
                "Avrupa Veri Korumasına Özel Bilgiler",
            CALIFORNIA_PRIVACY_RIGHTS: "Kaliforniya Gizlilik Hakları",
            CHANGES_TO_THIS_PRIVACY_STATEMENT:
                "Bu Gizlilik Bildirimindeki Değişiklikler",
            WHAT_PERSONAL_DATA_DO_WE_RECEIVE_DESCRIPTION:
                "Kişisel veriler, Maksellent'in bir gerçek kişiyle ilişkilendirebileceği bilgiler de dahil olmak üzere, kimliği belirli veya belirlenebilir bir kişiden gelen veya bunlarla ilgili her türlü bilgidir. Maksellent Ürünlerini kullandığınızda veya bunlarla etkileşim kurduğunuzda, müşterilerimiz adına aşağıdaki kişisel veri kategorilerini toplayabilir veya işleyebiliriz.",
            ACCOUNT_INFORMATION: "Account Information",
            ACCOUNT_INFORMATION_DESCRIPTION:
                "Yönetici adı, iletişim bilgileri, hesap kimliği, fatura bilgileri ve hesap planı bilgilerini içerebilen Maksellent Ürünlerini lisanslayan bir hesapla ilişkili bilgiler.",
            PROFILE_AND_PARTICIPANT_INFORMATION:
                "Profil ve Katılımcı Bilgileri",
            PROFILE_AND_PARTICIPANT_INFORMATION_DESCRIPTION:
                "Maksellent Ürünlerini lisanslı bir hesap altında kullanan veya bir toplantıya katılan lisanssız bir katılımcı tarafından sağlanan bir kullanıcının Maksellent profiliyle ilişkili, ad, ekran adı, resim, e-posta adresi, telefon numarası, iş bilgileri, belirtilen yerel ayarı içerebilen bilgiler , kullanıcı kimliği veya kullanıcı veya hesap sahibi tarafından sağlanan diğer bilgiler.",
            CONTACTS_AND_CALENDAR_INTEGRATION:
                "Kişiler ve Takvim Entegrasyonları",
            CONTACTS_AND_CALENDAR_INTEGRATION_DESCRIPTION:
                "Maksellent Ürünlerinde bir kullanıcının bir üçüncü taraf uygulamasından entegre ettiği iletişim bilgilerini içerebilen kişi listeleri oluşturmak için hesaplar veya kullanıcıları tarafından eklenen iletişim bilgileri. Kullanıcılar ayrıca diğer hizmetlerden takvimlerini Maksellent profilleri veya hesaplarıyla entegre edebilirler.",
            SETTINGS: "Ayarlar",
            SETTINGS_DESCRIPTION:
                "Ses ve video ayarları, kayıt dosyası konumu, ekran paylaşım ayarları ve diğer ayarlar ve yapılandırma bilgilerini içerebilen, bir Maksellent hesabı veya kullanıcı profilindeki tercihler ve ayarlarla ilişkili bilgiler.",
            REGISTRATION_INFORMATION: "kayıt Bilgileri",
            REGISTRATION_INFORMATION_DESCRIPTION:
                "Kişilerin bir Maksellent toplantısına, web seminerine veya kaydına kaydolurken sağladığı, ad ve iletişim bilgilerini, kayıt sorularına verilen yanıtları ve toplantı sahibi tarafından istenen diğer kayıt bilgilerini içerebilen bilgiler.",
            DEVICE_INFORMATION: "Cihaz bilgisi",
            DEVICE_INFORMATION_DESCRIPTION:
                "Hoparlörler, mikrofon, kamera, işletim sistemi sürümü, sabit disk kimliği, bilgisayar adı, MAC adresi, IP adresi (kullanılabilir) hakkında bilgileri içerebilen, Maksellent Ürünleri ile etkileşim kurarken kullanılan bilgisayarlar, telefonlar ve diğer cihazlar hakkında bilgiler. bir şehir veya ülke düzeyinde genel konum çıkarımı için), cihaz özellikleri (işletim sistemi sürümü ve pil seviyesi gibi), WiFi bilgileri ve diğer cihaz bilgileri (Bluetooth sinyalleri gibi).",
            MEETING_WEBINAR_AND_MESSAGING_CONTENT_AND_CONTEXT:
                "Toplantı, Web Semineri ve Mesajlaşma İçeriği ve Bağlamı",
            MEETING_WEBINAR_AND_MESSAGING_CONTENT_AND_CONTEXT_DESCRIPTION:
                "Toplantılarda, web seminerlerinde veya Maksellent Ürünlerinde barındırılan mesajlarda oluşturulan, ses, video, toplantı içi mesajlar, sohbet mesajı içeriği, dökümler, yazılı geri bildirim, anketlere ve Soru-Cevap yanıtları ve dosyalar ile ilgili içerik davet ayrıntıları, toplantı veya sohbet adı veya toplantı gündemi gibi bağlam. İçerik, hesap sahibinin ayarlarına, neyi paylaşmayı seçtiğinize, ayarlarınıza ve Maksellent Ürünlerinde ne yaptığınıza bağlı olarak sesinizi ve görüntünüzü içerebilir.",
            PRODUCT_AND_WEBSITE_USAGE: "Ürün ve Web Sitesi Kullanımı",
            PRODUCT_AND_WEBSITE_USAGE_DESCRIPTION:
                "Kişilerin ve cihazlarının Maksellent Ürünleri ile nasıl etkileşime girdiğine ilişkin bilgiler, örneğin: katılımcılar bir toplantıya ne zaman katılıp toplantıdan ayrılırsa; katılımcıların mesaj gönderilip gönderilmediği ve kiminle mesajlaştığı; performans verisi; fare hareketleri, tıklamalar, tuş vuruşları veya eylemler (sesi kapatma/açma veya videoyu açma/kapatma gibi) ve Maksellent'in özellik kullanımını anlamasına, ürün tasarımını iyileştirmesine ve özellikler önermesine yardımcı olan diğer kullanıcı girdileri; kullanıcıların bir toplantıya veya başka bir Ürüne hangi üçüncü taraf uygulamalarını ekledikleri ve uygulamanın hangi bilgilere ve eylemlere erişme ve gerçekleştirme yetkisine sahip olduğu; üçüncü şahıs uygulamalarının ve Maksellent App Marketplace'in kullanımı; kullanılan özellikler (ekran paylaşımı, emojiler veya filtreler gibi); ve diğer kullanım bilgileri ve ölçümleri. Bu ayrıca, hangi sayfalara eriştikleri, web sitesi özellikleriyle etkileşimleri ve bir Maksellent Ürünü için kaydolup kaydolmadıkları da dahil olmak üzere, insanların Maksellent'in web sitelerini ne zaman ve nasıl ziyaret ettikleri ve bunlarla nasıl etkileşimde bulundukları hakkında bilgileri içerir.",
            COMMUNICATIONS_WITH_MAKSELLENT: "Maksellent ile iletişim",
            COMMUNICATIONS_WITH_MAKSELLENT_DESCRIPTION:
                "Destek soruları, hesabınız ve diğer sorular dahil olmak üzere Maksellent ile olan iletişiminiz hakkında bilgiler.",
            INFORMATION_FROM_PARTNERS: "Ortaklardan Bilgi",
            INFORMATION_FROM_PARTNERS_DESCRIPTION:
                "Maksellent, hesap sahibinin şirket büyüklüğü veya sektörü, iletişim bilgileri veya belirli kurumsal etki alanlarının etkinliği hakkında bilgiler de dahil olmak üzere, pazar verileri zenginleştirme hizmetleri gibi üçüncü taraf şirketlerden hesap sahipleri ve kullanıcıları hakkında bilgiler alır. Maksellent ayrıca, size gösterdikleri bir reklama tıklayıp tıklamadığınız gibi, Maksellent Ürünlerinde görüntülenen reklamları yayınlayan üçüncü taraf reklam ortaklarından da bilgi alabilir.",
            HOW_DO_WE_USE_PERSONAL_DATA_DESCRIPTION_ONE:
                "Maksellent çalışanları, bir hesap sahibi tarafından yönlendirilmedikçe veya aşağıda tartışıldığı gibi yasal, güvenlik veya güvenlik nedenleriyle gerekmedikçe toplantı, web semineri veya mesajlaşma içeriğine (özellikle ses, video, dosya ve mesajlar) erişmez. Maksellent, kişisel verileri aşağıdaki faaliyetleri yürütmek için kullanır",
            PROVIDE_MAKSELLENT_PRODUCTS_AND_SERVICES:
                "Maksellent Ürün ve Hizmetlerini Sağlayın",
            PROVIDE_MAKSELLENT_PRODUCTS_AND_SERVICES_DESCRIPTION:
                "Hesap sahiplerine, kullanıcılarına ve hesaplarında düzenlenen toplantılara ve web seminerlerine katılmaya davet ettikleri kişilere, Maksellent Ürün özelliklerini ve hesaplar veya kullanıcıları için önerileri özelleştirmek de dahil olmak üzere Ürünler, özellikler ve hizmetler sağlamak. Maksellent ayrıca, kişiler Maksellent Ürünlerini kullanarak davet ve mesaj gönderdiğinde alıcılara davetleri ve mesajları yönlendirmek için iletişim bilgileri de dahil olmak üzere kişisel verileri kullanır. Bu ayrıca, hesap sahibinin veya kullanıcılarının talimatıyla ses, video, dosyalar ve mesajlara erişmeyi içerebilen müşteri desteği için kişisel verilerin kullanılmasını içerebilir. Kişisel verileri ayrıca faturalandırma, sözleşme yükümlülüklerine uyum ve ilgili yönetim dahil olmak üzere hesap sahipleriyle olan ilişkilerimizi ve sözleşmelerimizi yönetmek için kullanırız.",
            PRODUCT_RESEARCH_AND_DEVELOPMENT: "Ürün Araştırma ve Geliştirme",
            PRODUCT_RESEARCH_AND_DEVELOPMENT_DESCRIPTION:
                "Örneğin içerikle ilgili özellikler (arka plan filtreleri gibi) dahil olmak üzere Maksellent Ürünlerini geliştirmek, test etmek ve iyileştirmek ve ürün ve özelliklerin sorunlarını gidermek.",
            MARKETING_PROMOTIONS_AND_THIRD_PARTY_ADVERTISING:
                "Pazarlama, Promosyonlar ve Üçüncü Taraf Reklamları",
            MARKETING_PROMOTIONS_AND_THIRD_PARTY_ADVERTISING_DESCRIPTION:
                "Maksellent ve/veya üçüncü şahıs pazarlama ortaklarının, ürün kullanımınıza, üçüncü şahıs ortaklardan aldığımız bilgilere veya web sitelerimizi ziyaret etmenize, bilgilere dayanarak Maksellent Ürünlerini, özelliklerini ve hizmetlerini pazarlamasına, reklamını yapmasına ve tanıtmasına izin vermek için nasıl ve ne zaman ziyaret ettiğiniz ve onlarla etkileşimleriniz hakkında. Çerezleri veya üçüncü taraf reklam ortakları da dahil olmak üzere benzer teknolojiyi, size Maksellent Ürünleri içinde üçüncü tarafların ürünleri, hizmetleri veya amaçları hakkında reklamlar göstermek için de kullanabiliriz. Maksellent, herhangi bir pazarlama, promosyon veya üçüncü taraf reklam amacıyla toplantı, web semineri veya mesajlaşma içeriğini (özellikle ses, video, dosya ve mesajlar) KULLANMAZ.",
            AUTHENTICATION_INTEGRITY_SECURITY_AND_SAFETY:
                "Kimlik Doğrulama, Bütünlük, Güvenlik ve Güvenlik",
            AUTHENTICATION_INTEGRITY_SECURITY_AND_SAFETY_DESCRIPTION:
                "Hesapların ve etkinliklerin kimliğini doğrulamak, kötü niyetli davranışları veya güvenli olmayan deneyimleri tespit etmek, araştırmak ve önlemek, güvenlik tehditlerini ele almak, kamu güvenliğini korumak ve Maksellent Ürünlerinin güvenliğini sağlamak.",
            COMMUNICATE_WITH_YOU: "Sizinle iletişim kurun",
            COMMUNICATE_WITH_YOU_DESCRIPTION:
                "Kişisel verileri (iletişim bilgileri dahil) sizinle ürün güncellemeleri, hesabınız ve politika ve koşullarımızdaki değişiklikler dahil olmak üzere Maksellent Ürünleri, özellikleri ve hizmetleri hakkında iletişim kurmak için kullanırız. Bilgilerinizi, bizimle iletişime geçtiğinizde size yanıt vermek için de kullanırız.",
            LEGAL_REASONS: "Yasal Sebepler",
            LEGAL_REASONS_DESCRIPTION:
                "Yürürlükteki yasalara uymak veya kolluk kuvvetleri veya devlet kurumları dahil olmak üzere geçerli yasal sürece yanıt vermek, sivil keşif, dava veya diğer çekişmeli yasal işlemleri araştırmak veya bunlara katılmak ve Hizmet Koşullarımızın veya politikalarımızın olası ihlallerini uygulamak veya araştırmak için.",
            HOW_DO_WE_USE_PERSONAL_DATA_DESCRIPTION_TWO:
                "Maksellent, şartlarımızın veya politikalarımızın ihlallerini ve yasa dışı veya diğer zararlı faaliyetleri tespit etmek ve önlemek amacıyla sanal arka planlar, profil resimleri ve sohbet yoluyla yüklenen veya değiş tokuş edilen dosyalar gibi içeriği otomatik olarak taramak için gelişmiş araçlar kullanır ve çalışanları bu tür şeyleri araştırabilir. yasal, güvenlik veya güvenlik nedenleriyle gerekli olduğunda içerik.",
            HOW_DO_WE_SHARE_PERSONAL_DATA_DESCRIPTION:
                "Maksellent, kişisel verileri üçüncü taraflara yalnızca rıza ile veya aşağıdaki durumlardan birinde sağlar (geçerli yasa uyarınca gerekli olduğu durumlarda önceden rızanıza tabidir):",
            RESELLERS: "Bayiler",
            RESELLERS_DESCRIPTION:
                "Bir hesap sahibi, Maksellent Ürünlerini üçüncü taraf bir Maksellent Ürünleri bayisinden lisanslamış veya satın almışsa, bayi, hesap sahibi tarafından barındırılan toplantılar, web seminerleri ve mesajlar dahil olmak üzere kullanıcılar için kişisel verilere ve içeriğe erişebilir.",
            VENDORS: "Satıcılar",
            VENDORS_DESCRIPTION:
                "Maksellent, Maksellent Ürünlerini ve teknik altyapıyı sağlamak, desteklemek ve geliştirmek için ve ödeme işleme gibi ticari hizmetler için üçüncü şahıs hizmet sağlayıcılarla birlikte çalışır. Maksellent, Maksellent Ürünleri ile ilgili reklamlar ve iş analitiği sağlamak için üçüncü şahıs hizmet sağlayıcılarla da çalışabilir. Bu satıcılar, kişisel verilerin korunmasına ve kişisel verilerin Maksellent'a hizmet sağlamak dışında veya kanunların gerektirdiği amaçlar dışında herhangi bir amaçla kullanılmasını yasaklamaya yönelik sözleşme ve teknik gerekliliklere tabi olarak kişisel verilere erişebilir.",
            FOR_LEGAL_REASONS: "Hukuki Sebepler İçin",
            FOR_LEGAL_REASONS_DESCRIPTION:
                "Maksellent, kişisel verileri gerektiği şekilde paylaşabilir: (1) yürürlükteki yasalara uymak veya kolluk kuvvetleri veya devlet kurumları dahil olmak üzere geçerli yasal süreç ve işlemlere yanıt vermek, soruşturmak veya bunlara katılmak; (2) Hizmet Koşullarının veya politikalarının olası ihlallerini uygulamak veya araştırmak; (3) halka yönelik tehditler de dahil olmak üzere olası dolandırıcılık, suistimal veya güvenlik ve güvenlik endişelerini tespit etmek, önlemek veya araştırmak; (4) kurumsal ve sosyal sorumluluk taahhütlerimizi yerine getirmek; (5) bizim ve müşterilerimizin haklarını ve mülkiyetini korumak; ve (6) anlaşmazlıkları çözmek ve anlaşmaları uygulamak.",
            MARKETING_ADVERTISING_AND_ANALYTICS_PARTNERS:
                "Pazarlama, Reklamcılık ve Analitik İş Ortakları",
            MARKETING_ADVERTISING_AND_ANALYTICS_PARTNERS_DESCRIPTION:
                "Maksellent, üçüncü şahıs pazarlama, reklam ve analiz sağlayıcılarını kullanır: insanların Maksellent Ürünlerini ve web sitemizi nasıl kullandığına dair istatistikler ve analizler sağlamak; Web sitemizi kullanımınıza dayalı hedefli reklamlar dahil olmak üzere Maksellent Ürünleri için reklam ve pazarlama sağlamak; ve size Maksellent Ürünleri içinde üçüncü taraf reklamlarını göstermek için. Bu üçüncü taraf ortaklar, Maksellent'in web sitesine yerleştirilen üçüncü taraf çerezleri aracılığıyla Maksellent'in web sitesindeki faaliyetleriniz hakkında bilgi alabilir. Bu ortaklarla veri paylaşan üçüncü taraf çerez kullanımımızı devre dışı bırakmak için, mevcut Çerez Ayarları olan çerez yönetim aracımızı ziyaret edin. Yasaların gerektirdiği durumlarda, Maksellent, açıklanan pazarlama veya reklam faaliyetlerine katılmadan önce öncelikle onayınızı alacaktır.",
            CORPORATE_AFFILIATES: "Kurumsal İştirakler",
            CORPORATE_AFFILIATES_DESCRIPTION:
                "Maksellent, sahteciliği tespit etmek, araştırmak ve önlemek için Maksellent Ürünleri genelinde entegre ve tutarlı deneyimler sağlamak (bir kullanıcının bir Maksellent Telefon görüşmesini bir toplantıya entegre etmesini sağlamak gibi) sağlamak için kişisel bilgileri Maksellent Voice Communications, Inc. gibi kurumsal bağlı kuruluşlarla paylaşır. , suistimal ve kamu güvenliğine yönelik tehditler.",
            CHANGE_OF_CONTROL: "Kontrol değişikliği",
            CHANGE_OF_CONTROL_DECRIPTION:
                "Maksellent'in işinin veya varlıklarının tamamını veya bir kısmını içeren herhangi bir satış, birleşme, devralma, yeniden yapılandırma veya kontrol değişikliği müzakereleri sırasında veya müzakereleri sırasında, kişisel verileri fiili veya muhtemel edinicilerle, onların temsilcileriyle ve diğer ilgili katılımcılarla paylaşabiliriz. iflas veya benzeri işlemlerle bağlantısı.",
            WHO_CAN_SEE_AND_SHARE_MY_PERSONAL_DATA_WHEN_I_USE_MAKSELLENT_DESCRIPTION:
                "Maksellent üzerinde mesaj gönderdiğinizde veya toplantılara ve web seminerlerine katıldığınızda, toplantı, web semineri veya mesajın dışındaki üçüncü taraflar da dahil olmak üzere diğer kişi ve kuruluşlar, paylaştığınız içerik ve bilgileri görebilir:",
            ACCOUNT_OWNER: "Account Owner",
            ACCOUNT_OWNER_ONE:
                'Hesap sahibi, bir Maksellent hesabına kaydolan kuruluş veya kişidir. Tipik olarak, bir hesap sahibi, hesabını yönetmek için bir veya daha fazla kişiyi ("yönetici" olarak adlandırılır) belirler ve hesaptaki kullanıcılara ayrıcalıklar verebilir. Maksellent ile sahip oldukları lisansa bağlı olarak hesap sahibi, hesabında ek kullanıcıları yetkilendirebilir ve hesap sahibi, hesabındaki tüm kullanıcılar için profil bilgileri oluşturabilir ve/veya bunlara erişebilir. Hesap sahibi ve kullanıcıları, başkalarını (hesaplarında olmayan misafirler dahil) hesaplarında düzenlenen toplantılara veya web seminerlerine davet edebilir.',
            ACCOUNT_OWNER_TWO:
                "Maksellent, hesap sahiplerine, kayıtlar veya toplantı dışı mesajlar gibi belirli içerik türlerinin oluşturulup oluşturulamayacağını veya gönderilip gönderilemeyeceğini ve toplantılar ve web seminerleri için hangi üçüncü taraf uygulamalarının kullanılabileceğini belirlemek için kullanabilecekleri kontroller ve özellikler sağlar. hesaplarında barındırılıyor. Hesap sahipleri ve belirledikleri kişiler, ayarlarına bağlı olarak, hesaplarında toplantılara ve web seminerlerine katılan veya hesaplarında kullanıcılara mesaj gönderen kişilerin kişisel verilerine erişebilir. Özellikle, hesap sahiplerinin şunlara erişimi olabilir:",
            ACCOUNT_USAGE: "Hesap Kullanımı",
            PRODUCT_USAGE: "Ürün Kullanımı",
            PRODUCT_USAGE_DESCRIPTION:
                "Sohbette kullanıcılarına kimlerin mesaj gönderdiğini, e-posta adreslerini, IP adreslerini, cihaz bilgilerini ve hesaplarında toplantılara veya web seminerlerine kimlerin katıldığı, kullanıcıların görüntüleyip görüntülemediği veya indirilen bir kayıt, kişilerin toplantılara ne kadar süre katıldıkları, mesajın ne zaman gönderildiği, Maksellent Phone entegrasyonları hakkında bilgiler ve diğer kullanım bilgileri ve geri bildirim metrikleri.",
            PARTICIPANT_LIST: "Katılımcı listesi",
            PARTICIPANT_LIST_DESCRIPTION:
                "Ad, görünen ad, e-posta adresi, telefon numarası ve katılımcı veya kullanıcı kimliğini içerebilen bir Maksellent toplantısı, web semineri veya sohbetindeki katılımcılar hakkında bilgiler.",
            REGISTRATION_INFORMATION_DESCRIPTION_NEW:
                "Hesap tarafından barındırılan bir web semineri, toplantı veya kayıt için kayıt sırasında sağlanan bilgiler.",
            MAKSELLENT_CHAT_OUT_OF_MEETING_MESSAGE:
                "Maksellent Sohbet Toplantı Dışı Mesajları",
            MAKSELLENT_CHAT_OUT_OF_MEETING_MESSAGE_DESCRIPTION:
                "Hesap sahipleri, hesaplarında etkinleştirilirse, mesajla ilgili bilgilerle birlikte (örneğin, tarih ve saat ve katılımcı sayısı) hesaplarındaki kullanıcılara toplantı dışı mesajları kimin gönderip aldığına ilişkin bilgileri görebilir. Hesap sahipleri, ayarlarına bağlı olarak, hesap sahibi Gelişmiş Sohbet Şifrelemesini etkinleştirmediği sürece, hesaplarındaki kullanıcılara ve kullanıcılardan gönderilen mesajların içeriğiyle birlikte gönderen ve alıcı bilgilerini ve diğer mesajlaşma verilerini de görebilir.",
            IN_MEETING_WEBINAR_MESSAGES: "Toplantı İçi/Web Semineri Mesajları",
            IN_MEETING_WEBINAR_MESSAGES_DESCRIPTION:
                "Hesap sahipleri, ayarlarına bağlı olarak, aşağıdaki durumlarda hesaplarındaki kullanıcılara ve kullanıcılardan gönderilen mesajların içeriğiyle birlikte gönderen ve alıcı bilgilerini görebilir:",
            MESSAGE_SENT_TO_EVERYONE_IN_A_MEETING_THAT_IS_RECORDED:
                "Kaydedilmiş bir toplantıda Herkese gönderilen mesajlar",
            MESSAGE_SENT_TO_PANELISTS_IN_A_WEBINAR_THAT_IS_RECORDED:
                "Kaydedilen bir web seminerinde panelistlere gönderilen mesajlar",
            DIRECT_MESSAGES_IF_THE_ACCOUNT_OWNER_HAS_ENABLED_ARCHIVING:
                "Hesap sahibi arşivlemeyi etkinleştirmişse doğrudan mesajlar",
            RECORDINGS: "Kayıtlar",
            RECORDINGS_DESCRIPTION:
                "Hesap sahipleri, hesaplarında barındırılan toplantıların ve web seminerlerinin kayıtlarının içeriğini izleyebilir. Etkinleştirilmişse, toplantı sesinin dökümünü de görüntüleyebilirler.",
            POLLING_QA_AND_FEEDBACK: "Anket, Soru-Cevap ve Geri Bildirim",
            POLLING_QA_AND_FEEDBACK_DESCRIPTION:
                "Hesap sahipleri, yanıtlar anonim olarak gönderilmedikçe, anketlerine, Soru-Cevap'a kimin yanıt verdiği veya ad ve iletişim bilgileri de dahil olmak üzere toplantı veya web semineri geri bildirim istekleri ile ilgili bilgileri, yanıtlar veya geri bildirimlerle birlikte görebilir.",
            MEETING_HOSTS_AND_PARTICIPANTS:
                "Toplantı Sahipleri ve Katılımcılar",
            MEETING_HOSTS_AND_PARTICIPANTS_DESCRIPTION:
                "Toplantı sahipleri ve toplantıdaki diğer katılımcılar e-postanızı, görünen adınızı ve profil resminizi görebilir. Toplantı sahipleri ve katılımcılar ayrıca toplantı içeriğini, sesli dökümleri, Herkese veya doğrudan kendilerine gönderilen mesajları ve bir toplantı sırasında paylaşılan dosyaları, beyaz tahtaları veya diğer bilgileri görebilir ve (hesap sahibinin ayarlarına bağlı olarak) kaydedebilir veya kaydedebilir. Toplantı sahipleri ayrıca toplantı sırasında oluşturulan Soru-Cevap yanıtlarını ve anketleri görebilir.",
            WEBINAR_PANELISTS_AND_ATTENDEES:
                "Web Semineri Panelistleri ve Katılımcılar",
            WEBINAR_PANELISTS_AND_ATTENDEES_DESCRIPTION:
                "Bir web semineri sırasında katılımcılara yalnızca panelistler görünebilir, ancak sesi açmayı kabul eden katılımcılar diğer katılımcılar tarafından duyulabilir. Bir katılımcı bir web semineri sırasında panelist olmayı kabul ederse, ayarlara bağlı olarak diğer katılımcılar tarafından görülebilir. Panelistler ve katılımcılar, soruyu anonim olarak göndermediği sürece, Soru-Cevap sırasında soru soran bir katılımcının adını sorularıyla birlikte görebilir.",
            LIVESTREAMS: "Canlı yayınlar",
            LIVESTREAMS_DESCRIPTION:
                "Toplantı ve web semineri sahipleri, üçüncü taraf bir siteye veya hizmete canlı akış yapmayı seçebilir; bu, canlı akışa erişimi olan herkesin toplantıyı veya web seminerini görebileceği anlamına gelir.",
            THIRD_PARTY_APPS_AND_INTEGRATIONS:
                "Üçüncü Taraf Uygulamaları ve Entegrasyonları",
            THIRD_PARTY_APPS_AND_INTEGRATIONS_DESCRIPTION_ONE:
                "Hesap sahipleri, Maksellent App Marketplace'in kullanımı da dahil olmak üzere hesaplarına ve kullandıkları Maksellent Ürünlerine üçüncü kişi uygulamaları eklemeyi seçebilir ve ayrıca kullanıcılarının toplantılar dahil olmak üzere belirli üçüncü kişi uygulamalarını ekleyip kullanamayacaklarını kontrol edebilirler. , web seminerleri ve hesaplarında barındırılan sohbetler. Ayarlarına bağlı olarak, hesap sahipleri ve onların kullanıcıları ve misafirleri, kişisel verilerinizi ve içeriğinizi onayladıkları üçüncü taraf uygulamalar ve entegrasyonlarla paylaşabilir; bu, hesap sahipleri, ev sahipleri ve yukarıda listelenen katılımcılar için mevcut olan tüm kişisel verileri içerebilir. hesap bilgileri, profil ve iletişim bilgileri, kayıt bilgileri, katılımcı listesi, ayarlar, içerik, ürün kullanımı ve cihaz bilgileri olarak.",
            THIRD_PARTY_APPS_AND_INTEGRATIONS_DESCRIPTION_TWO:
                "Üçüncü taraf uygulaması toplantıdan gerçek zamanlı özellikler ve bilgiler alıyorsa, toplantıdaki diğer katılımcılar, toplantıda kullandığınız üçüncü taraf uygulamasını görebilir.",
            THIRD_PARTY_APPS_AND_INTEGRATIONS_DESCRIPTION_THREE:
                "Üçüncü şahıs geliştiriciler ayrıca Maksellent toplantılarını web sitelerine veya uygulama deneyimlerine entegre edebilir veya yerleştirebilir veya Maksellent'in üçüncü şahıs uygulamasından Maksellent Ürünlerine erişim sağlayan sürümlerini oluşturabilir.",
            THIRD_PARTY_APPS_AND_INTEGRATIONS_DESCRIPTION_FOUR:
                "Hesap sahipleri ve kullanıcılar tarafından üçüncü taraf uygulamalar ve entegrasyonlarla paylaşılan kişisel bilgiler, Maksellent'in değil, uygulama geliştiricilerinin şartlarına ve gizlilik politikalarına göre toplanır ve işlenir.",
            PRIVACY_RIGHTS_AND_CHOICES: "Gizlilik Hakları ve Seçimleri",
            PRIVACY_RIGHTS_AND_CHOICES_DESCRIPTION:
                "Avrupa Ekonomik Alanı (AEA), İsviçre veya Birleşik Krallık'ta bulunuyorsanız veya Kaliforniya'da ikamet ediyorsanız, lütfen aşağıdaki ilgili bölümlere bakın. Aksi takdirde, talebiniz üzerine ve yürürlükteki yasaların gerektirdiği şekilde:",
            PRIVACY_RIGHTS_AND_CHOICES_DESCRIPTION_ONE:
                "Sizinle ilgili elimizde bulunan ve kontrolümüz altında olan hangi kişisel verilere ilişkin sizi bilgilendirmek;",
            PRIVACY_RIGHTS_AND_CHOICES_DESCRIPTION_TWO:
                "Bu tür kişisel verileri veya seçtiğiniz önceki gizlilik tercihlerini değiştirmek veya düzeltmek veya sizi ilgili araçlara yönlendirmek; ve/veya",
            PRIVACY_RIGHTS_AND_CHOICES_DESCRIPTION_THREE:
                "Bu tür kişisel verileri silin veya sizi uygun araçlara yönlendirin.",
            PRIVACY_RIGHTS_AND_CHOICES_PARAGRAPH_ONE:
                "Maksellent tarafından kontrol edilen kişisel verilerle ilgili herhangi bir hakkınızı kullanmak için veya kişisel verilerinizi kullanımımız hakkında başka sorularınız varsa, lütfen bize bir talep gönderin.",
            PRIVACY_RIGHTS_AND_CHOICES_PARAGRAPH_TWO:
                "Lütfen kendinizi tanıtın ve Maksellent Ürünleri ile ilgili bilgiler için hesabınızı ve/veya kullanıcı bilgilerinizi ve kimliğinizi doğrulamamızı ve talebinize yanıt vermemizi sağlayacak diğer bilgileri belirtin. Yasal olarak izin verildiği durumlarda, makul olmayan bir şekilde tekrarlayan veya sistematik olan, orantısız talepler gerektiren talepleri işleme koymayı reddedebiliriz.",
            PRIVACY_RIGHTS_AND_CHOICES_PARAGRAPH_THREE:
                "teknik çaba sarf etmek veya başkalarının mahremiyetini tehlikeye atmak. Bir hesap sahibi veya lisanslı bir hesap altındaki bir kullanıcı olarak, hesabınızı ziyaret ederek ve kişisel verilerinizi doğrudan değiştirerek kişisel verilerinizi etkilemek için adımlar atabilirsiniz.",
            CHILDREN_PARAGRAPH_ONE:
                "Maksellent, 16 yaşından küçük çocukların Maksellent hesabına kaydolmasına izin vermez.",
            CHILDREN_PARAGRAPH_TWO:
                "18 yaşından küçük çocuklara eğitim hizmetleri sağlamak için Maksellent Ürünlerini kullanan eğitim kuruluşları için Maksellent'in Çocukların Eğitim Gizliliği Beyanı burada mevcuttur.",
            HOW_TO_CONTACT_US_DESCRIPTION:
                "Haklarınızı kullanmak için veya bu Gizlilik Bildirimi ile ilgili gizlilikle ilgili sorularınız veya yorumlarınız varsa, lütfen adresine bir e-posta gönderin.",
            HOW_TO_CONTACT_US_ADDRESS:
                "Ayrıca aşağıdaki adrese yazarak da bizimle iletişime geçebilirsiniz:",
            MAKSELLENT_VIDEO_COMMUNICATIONS: "Maksellent Görüntülü İletişim,",
            INC_ATTENTION_DATA_PRIVACY_OFFICER:
                "Inc. Dikkat: Veri Gizliliği Görevlisi",
            ALMADEN_BLVD_SUITE: "55 Almaden Bulvarı, Süit 600",
            SAN_JOSE_CA: "San Jose, CA 95113",
            HOW_TO_CONTACT_US_UK_ADDRESS:
                "Veya AB veya Birleşik Krallık'taki temsilcimize:",
            LIONHEART_SQUARED_LTD: "Aslan Yürekli Kare Ltd",
            ATTN_DATA_PRIVACY: "Dikkat: Veri Gizliliği",
            PEMBROKE_HOUSE: "2 Pembroke Evi",
            UPPER_PEMBROKE_STREET: "Yukarı Pembroke Caddesi 28-32",
            DUBLIN: "Dublin",
            DO_EK: "DO2 EK84",
            REPUBLIC_OF_LRELAND: "İrlanda Cumhuriyeti",
            EMAIL: "e-posta:",
            LIONHEART_SQUARED_LIMITED: "Aslan Yürekli Kare Sınırlı",
            GLASSHOUSE_STUDIOS: "17 Sera Stüdyosu",
            FRYERN_COURT_ROAD: "Friern Mahkemesi Yolu",
            FORDINGBRIDGE: "Fordingköprüsü",
            HAMPSHIRE: "Hampshire",
            SP_QX: "SP6 1QX",
            UNITED_KINGDOM: "Birleşik Krallık",
            CONTACT: "İletişimdekiler:",
            DATA_PROTECTION_OFFICER:
                "adresine bir e-posta göndererek Veri Koruma Görevlimiz ile iletişime geçebilirsiniz.",
            RETENTION_DESCRIPTION:
                "Yürürlükteki yasalar tarafından daha uzun bir saklama süresi gerekli olmadığı sürece, bu Gizlilik Bildiriminde açıklanan kullanımları gerçekleştirmek için gerekli olduğu sürece kişisel verileri saklarız.",
            RETENTION_RULES:
                "Saklama sürelerimizi belirlemek için kullanılan kriterler aşağıdakileri içerir:",
            RETENTION_RULES_ONE:
                "Sizinle devam eden bir ilişkimiz olduğu ve size Maksellent Ürünleri sağladığımız süre (örneğin, bizde bir hesabınız olduğu veya Ürünlerimizi kullanmaya devam ettiğiniz sürece);",
            RETENTION_RULES_TWO:
                "Hesap sahiplerinin hesapları üzerinden bilgileri değiştirmesi veya kullanıcılarının silmesi;",
            RETENTION_RULES_THREE:
                "Verileri saklamak için yasal bir yükümlülüğümüz olup olmadığı (örneğin, belirli yasalar, işlemlerinizin kayıtlarını silebilmemiz için belirli bir süre boyunca saklamamızı gerektirir); veya",
            RETENTION_RULES_FOUR:
                "Yasal konumumuz ışığında saklamanın tavsiye edilip edilmediği (sözleşmelerimizin uygulanması, anlaşmazlıkların çözümü ve geçerli zamanaşımı, dava veya düzenleyici soruşturma ile ilgili olarak).",
            DATA_SUBJECTS_RIGHTS: "Veri Sahibi Hakları",
            DATA_SUBJECTS_RIGHTS_DESCRIPTION:
                "AEA, İsviçre veya Birleşik Krallık'ta bulunuyorsanız, kontrolör olarak tarafımızca işlenen kişisel verilerinizle ilgili haklarınız özellikle şunları içerir:",
            RIGHT_OF_ACCESS_AND_OR_PORTABILITY:
                "Erişim ve/veya taşınabilirlik hakkı",
            RIGHT_OF_ACCESS_AND_OR_PORTABILITY_DESCRIPTION:
                'Hakkınızda tuttuğumuz tüm kişisel verilere erişme ve bazı durumlarda, bu verileri başka bir sağlayıcıya sunabilmeniz veya "taşıyabilmeniz" için bu verileri size verme hakkınız vardır;',
            RIGHT_OF_ERASURE: "Silme hakkı",
            RIGHT_OF_ERASURE_DESCRIPTION:
                "Belirli durumlarda, hakkınızda tuttuğumuz kişisel verileri silme hakkına sahipsiniz (örneğin, başlangıçta toplanma amaçları için artık gerekli değilse);",
            RIGHT_TO_OBJECT_TO_PROCESSING: "İşleme itiraz etme hakkı",
            RIGHT_TO_OBJECT_TO_PROCESSING_DESCRIPTION:
                "Belirli durumlarda, kişisel verilerinizi işlemeyi ve/veya size pazarlama iletişimleri göndermeyi durdurmamızı talep etme hakkınız vardır;",
            RIGHT_TO_RECTIFICATION: "Düzeltme hakkı",
            RIGHT_TO_RECTIFICATION_DESCRIPTION:
                "Herhangi bir yanlış veya eksik kişisel veriyi düzeltmemizi talep etme hakkınız vardır;",
            RIGHT_TO_RESTRICT_PROCESSING: "İşlemeyi kısıtlama hakkı",
            RIGHT_TO_RESTRICT_PROCESSING_DESCRIPTION:
                "Belirli durumlarda (örneğin, hakkınızda elimizde bulunan kişisel verilerin doğru olmadığına veya yasalara uygun olarak saklandığına inandığınız durumlarda) kişisel verilerinizin işlenmesini kısıtlamamızı talep etme hakkınız vardır.",
            RIGHT_TO_RESTRICT_PROCESSING_PARAGRAPH_ONE:
                "Maksellent tarafından kontrol edilen kişisel verilerle ilgili haklarınızdan herhangi birini kullanmak için veya kişisel verilerinizi kullanımımız hakkında başka sorularınız varsa, lütfen bu Gizlilik'in Bize Nasıl Ulaşılır bölümünde belirtilen iletişim bilgilerine bir talep gönderin. Beyan. Kimliğinizi doğrulamak ve ilgili kişisel verilere erişim hakkınız olduğundan emin olmak için bize ek bilgiler vermenizi talep edebileceğimizi lütfen unutmayın.",
            RIGHT_TO_RESTRICT_PROCESSING_PARAGRAPH_TWO:
                "Ayrıca bir veri koruma makamına şikayette bulunma hakkına da sahipsiniz. Daha fazla bilgi için lütfen yerel veri koruma yetkilinize başvurun.",
            LEGAL_BASIS_FOR_PROCESSING_PERSONAL_DATA:
                "Kişisel Verilerin İşlenmesinin Hukuki Dayanağı",
            LEGAL_BASIS_FOR_PROCESSING_PERSONAL_DATA_DESCRIPTION:
                "Bilgilerinizi yalnızca yasal, şeffaf ve adil bir şekilde kullanırız. İlgili belirli kişisel verilere ve fiili bağlama bağlı olarak, Maksellent kişisel verileri AEA, İsviçre ve Birleşik Krallık gibi bölgelerdeki bireyler için bir kontrolör olarak işlediğinde, yargı alanınızda geçerli olan aşağıdaki yasal temellere güveniriz:",
            AS_NECESSARY_FOR_OUR_CONTACT: "Sözleşmemiz için gerektiği gibi",
            AS_NECESSARY_FOR_OUR_CONTACT_DESCRIPTION:
                "Sizinle doğrudan bir sözleşme akdettiğimizde, sözleşmeyi hazırlamak ve akdetmenin yanı sıra sözleşmemizi ifa etmek ve yönetmek (yani Maksellent Ürünlerini, özelliklerini ve hizmetlerini sağlamak) için sözleşmemize dayalı olarak kişisel verilerinizi işleriz. hesap sahiplerine, kullanıcılarına ve hesaplarında barındırılan toplantılara ve web seminerlerine katılmaya davet ettikleri kişilere ve faturalandırma, sözleşme yükümlülüklerine uygunluk ve ilgili yönetim dahil olmak üzere ilişkimizi ve sözleşmemizi yönetmeye). Kişisel verilerinizi bu amaçlarla işlemezsek, size tüm Ürünleri, özellikleri ve hizmetleri sağlayamayabiliriz;",
            CONSOSTENT_WITH_SPECIFIC_REVOCABLE_CONSENTS:
                "Belirli iptal edilebilir izinlerle tutarlı",
            CONSOSTENT_WITH_SPECIFIC_REVOCABLE_CONSENTS_DESCRIPTION:
                "Özel reklamcılık ve web sitesi kullanımımızın analizini sunmak üzere reklamcılık ve analiz ortaklarıyla etkileşimde bulunmak üzere çerezleri kullanmak için önceden izninize güveniyoruz. Çerez yönetim aracımızı, mevcut Çerez Ayarlarını ziyaret ederek, istediğiniz zaman onayınızı geri çekme hakkına sahipsiniz;",
            AS_NECESSARY_TO_COMPLY_WITH_OUR_LEGAL_OBLIGATIONS:
                "Yasal yükümlülüklerimize uymak için gerektiğinde",
            AS_NECESSARY_TO_COMPLY_WITH_OUR_LEGAL_OBLIGATIONS_DESCRIPTION:
                "Kişisel verilerinizi, AEA yasalarına, yönetmeliklerine, uygulama kurallarına, kılavuzlarına veya bizim için geçerli olan kurallara uygunluk amaçlarıyla tabi olduğumuz yasal yükümlülüklere uymak ve bizden gelen taleplere ve diğer iletişimlere yanıt vermek için işleriz. , yetkili AÇA kamu, hükümet, yargı veya diğer düzenleyici makamlar. Buna hileli, zararlı, yetkisiz veya yasa dışı faaliyetlerin (“dolandırıcılık ve kötüye kullanımın tespiti”) ve gizlilik yasalarına uygunluğun tespit edilmesi, araştırılması, önlenmesi ve durdurulması;",
            TO_PROTECT_YOUR_VITAL_INTERESTS_OR_THOSE_OF_OTHERS:
                "Hayati çıkarlarınızı veya başkalarının çıkarlarını korumak için",
            TO_PROTECT_YOUR_VITAL_INTERESTS_OR_THOSE_OF_OTHERS_DESCRIPTION:
                "Çocukların cinsel istismarı materyalleri de dahil olmak üzere hayati menfaatleri ve kamu güvenliğini etkileyen yasa dışı faaliyetleri tespit etmek ve önlemek amacıyla hayati menfaatleri korumak için belirli kişisel verileri işleriz; ve",
            AS_NECESSARY_FOR_OUR_LEGITIMATE_INTERESTS:
                "Kişisel verilerin korunmasını gerektiren menfaatleriniz veya temel hak ve özgürlükleriniz bu menfaatlerin önüne geçmedikçe, bizim (veya başkalarının) meşru menfaatleri için gerekli olduğu şekilde",
            AS_NECESSARY_FOR_OUR_LEGITIMATE_INTERESTS_DESCRIPTION_ONE:
                "Kişisel verilerinizi (i) hesapla sözleşmeye girmek ve ifa etmek için bu tür meşru menfaatlere dayalı olarak işleriz.",
            AS_NECESSARY_FOR_OUR_LEGITIMATE_INTERESTS_DESCRIPTION_TWO:
                "owner and/or reseller providing you with the Products (which includes billing, compliance with contractual obligations, and related administration and support); (ii) develop, test, and improve our Products and troubleshoot products and features; (iii) ensure authentication, integrity, security, and safety of accounts, activity, and Products, including detect and prevent malicious conduct and violations of our terms and policies, prevent or investigate bad or unsafe experiences, and address security threats; (iv) send marketing communications, advertising, and promotions related to the Products; and (v) comply with non-EEA laws, regulations, codes of practice, guidelines, or rules applicable to us and respond to requests from, and other communications with, competent non-EEA public, governmental, judicial, or other regulatory authorities, as well as meet our corporate and social responsibility commitments, protect our rights and property and the ones of our customers, resolve disputes, and enforce agreements.",
            INTERNATIONAL_DATA_TRANSFERS: "Uluslararası Veri Transferleri",
            INTERNATIONAL_DATA_TRANSFERS_PRAGRAPH_ONE:
                "Maksellent küresel olarak faaliyet göstermektedir; bu, kişisel verilerin aktarılabileceği, saklanabileceği (örneğin, bir veri merkezinde) ve ilk olarak toplandığı ülke veya bölge dışında, Maksellent veya hizmet sağlayıcılarının müşterilerinin veya tesislerinin bulunduğu, ülkeler de dahil olmak üzere işlenebileceği anlamına gelir. katıldığınız toplantılara veya web seminerlerine ev sahipliği yapan veya gönderdiğiniz mesajları alan toplantı katılımcıları veya hesap sahipleri esas alınır.",
            INTERNATIONAL_DATA_TRANSFERS_PRAGRAPH_TWO:
                "Bu nedenle, Maksellent Ürünlerini kullanarak veya yukarıda belirtilen amaçlardan herhangi biri için kişisel veriler sağlayarak, kişisel verilerinizin, yerleşik olduğumuz Amerika Birleşik Devletleri'nin yanı sıra AEA dışındaki diğer ülkelere aktarılabileceğini veya saklanabileceğini kabul etmektesiniz, İsviçre ve İngiltere. Bu tür ülkelerde, sizin ülkenizden farklı ve daha az koruyucu veri koruma kuralları olabilir.",
            INTERNATIONAL_DATA_TRANSFERS_PRAGRAPH_THREE:
                "Kişisel verilerinizi nerede işlenirse işlensin bu Gizlilik Bildirimi uyarınca koruyoruz ve bunları geçerli yasalar kapsamında korumak için uygun sözleşme veya diğer adımları atıyoruz. AEA, İsviçre veya Birleşik Krallık'taki kullanıcıların kişisel verileri, AEA, İsviçre veya Birleşik Krallık dışında, yeterli düzeyde veri korumasına sahip olarak tanınmayan bir ülkede bulunan bir alıcıya aktarılıyorsa, aşağıdakileri sağlarız: devir, Avrupa Komisyonu'nun standart sözleşme hükümlerine tabidir. Bu konuda daha fazla bilgi almak isterseniz lütfen bizimle iletişime geçin.",
            CALIFORNIA_CONSUMER_PRIVACY_ACT:
                "Kaliforniya Tüketici Gizliliği Yasası",
            CALIFORNIA_CONSUMER_PRIVACY_ACT_DESCRIPTION:
                "2018 Kaliforniya Tüketici Gizliliği Yasası (CCPA) uyarınca, Kaliforniya sakinleri aşağıdaki haklara sahip olabilir:",
            CALIFORNIA_CONSUMER_PRIVACY_ACT_ACCESS:
                "Maksellent'in topladığı kişisel verilerin kategorilerine ve belirli parçalarına, kişisel verilerin toplandığı kaynakların kategorilerine, kişisel verilerin toplanmasına ilişkin iş amaç(lar)ına ve Maksellent'ın kişisel verileri paylaştığı üçüncü tarafların kategorilerine erişim ;",
            CALIFORNIA_CONSUMER_PRIVACY_ACT_DELETE:
                "Belirli koşullar altında kişisel verileri silin; ve",
            CALIFORNIA_CONSUMER_PRIVACY_ACT_OPT_OUT_OF_THE_SALE_ONE:
                'Kişisel verilerin "satışını" devre dışı bırakın. Kişisel verilerinizi geleneksel anlamda satmıyoruz. Bununla birlikte, birçok şirket gibi, çevrimiçi etkinliğiniz hakkında çerezler ve benzer teknolojiler aracılığıyla toplanan bilgilere dayanarak çevrimiçi reklamları ilgi alanlarınıza göre uyarlamaya çalışan reklamcılık hizmetleri kullanıyoruz. Buna ilgi alanına dayalı reklamcılık denir. CCPA\'nın "satış" teriminin yasal tanımı geniştir ve ilgi alanına dayalı reklamcılığı içerebilir. Daha fazla bilgi alabilir ve sitelerimizde çerez kullanımını devre dışı bırakabilirsiniz.',
            CALIFORNIA_CONSUMER_PRIVACY_ACT_OPT_OUT_OF_THE_SALE_TWO:
                "ilgi alanına dayalı reklamcılık amacıyla, yine ana sayfamızda bulunan Kişisel Bilgilerimi Satma Kişisel Bilgilerimi Satma bağlantısına tıklayarak ve tercihlerinizi belirleyerek. Olacaksın",
            CALIFORNIA_CONSUMER_PRIVACY_ACT_OPT_OUT_OF_THE_SALE_THREE:
                "tercihlerinizi her cihazdan ve çıkmak istediğiniz her web tarayıcısından ayarlamanız gerekir. Bu özellik, tercihinizi hatırlamak için bir tanımlama bilgisi kullanır, bu nedenle tarayıcınızdaki tüm tanımlama bilgilerini temizlerseniz, ayarlarınızı sıfırlamanız gerekir.",
            CALIFORNIA_CONSUMER_PARAGRAPH_ONE:
                "Maksellent, CCPA kapsamındaki haklarınız ile daha uyumlu olan bu haklardan herhangi birini kullandığınız için size karşı ayrımcılık yapmayacaktır.",
            CALIFORNIA_CONSUMER_PARAGRAPH_TWO:
                "Haklarınızı kullanmak için e-posta ile bize ulaşın",
            CALIFORNIA_CONSUMER_PARAGRAPH_THREE:
                "Talebinizin alındığını 10 iş günü içinde bildireceğiz ve 45 takvim günü içinde önemli bir yanıt vereceğiz ya da gerekçesini ve uzatma süresini (90 güne kadar) yazılı olarak size bildireceğiz.",
            CALIFORNIA_CONSUMER_PARAGRAPH_FOUR:
                "CCPA kapsamında, kişisel verilerinizle ilgili olarak yalnızca siz veya yetkili bir temsilci talepte bulunabilir. CCPA kapsamında kişisel verilere erişme veya bunları silme isteklerinize yanıt verebilmek için kimliğinizi doğrulamamız gerektiğini unutmayın. Bunu, (varsa) Maksellent hesabınızda oturum açmanızı, hesabınızla ilgili bilgileri sağlamanızı (profil bilgileri gibi sahip olduğumuz bilgilerle karşılaştırılacaktır), kimliğinize ilişkin bir beyanda bulunmanızı, yalan yere yemin etme ve/veya ek bilgi sağlama. Yazılı izin vererek ve kimliğinizi doğrulayarak veya vekaletname yoluyla doğrulanmış tüketici talebinizi göndermesi için yetkili bir temsilci atayabilirsiniz.",
            CALIFORNIA_CONSUMER_PARAGRAPH_FIVE:
                "veya +1-888-799-9666 numaralı telefonu arayın. İlgi alanına dayalı reklamcılık amacıyla sitelerimizde çerez kullanımını devre dışı bırakmak için yukarıdaki talimatları izleyin.",
            CALIFORNIAS_SHINE_THE_LIGHT_LAW:
                "California'nın Shine the Light Yasası",
            CALIFORNIAS_SHINE_THE_LIGHT_LAW_DESCRIPTION:
                "“Shine The Light” yasası olarak da bilinen California Medeni Kanunu Bölüm 1798.83, California'da ikamet edenlerin, Kişisel Bilgilerinizin (varsa) üçüncü şahısların doğrudan pazarlama amaçları için bir önceki takvim yılında üçüncü şahıslara ifşa edilmesine ilişkin yıllık olarak bilgi talep etmesine izin verir. . Kişisel Bilgileri üçüncü şahısların doğrudan pazarlama amaçları için üçüncü şahıslarla paylaşmayız.",
            CHANGES_TO_THIS_PRIVACY_STATEMENT_DESCRIPTION:
                "Kişisel verilerin toplanması ve/veya işlenmesindeki değişiklikleri hesaba katmak için bu Gizlilik Bildirimini periyodik olarak güncelleyebiliriz ve güncellenmiş Gizlilik Bildirimini en üstte “Son Güncelleme” tarihi ile web sitemizde yayınlayacağız. Bu Gizlilik Bildiriminde önemli değişiklikler yaparsak, sizi bilgilendireceğiz ve Ürünlerimizi kullanmaya devam etmeyi seçmeden önce size inceleme fırsatı sunacağız.",
        },

        CALENDAR: {
            CREATE_TASK: "Görev Oluştur",
            EVENTS: "Olaylar",
            COMPLETED_TASKS: "Tamamlanmış Görevler",
            PENDING_TASKS: "Bekleyen görevler",
            MY_CALENDARS: "Takvimlerim",
            WORK: "Çalışmak",
            TRIP: "Seyahat",
            FUNCTIONS: "Fonksiyonlar",
            EVENT: "Etkinlik",
            CHOOSE_START_TIME: "Başlangıç ​​Zamanını Seçin",
            ALL_DAY: "Tüm gün",
            CHOOSE_END_TIME: "Bitiş Zamanını Seçin",
            SCHEDULE: "Takvim",
            SELECT_SCHEDULE: "Program Seç",
            PRIVATE_TASK: "Özel Görev",
            OPEN_TASK_ON_MY_TASKS_AFTER_SAVE:
                "Kaydettikten sonra Görevlerim'de görevi aç",
            TIME_ZONE: "SAAT DİLİMİ:",
            ADD_GUEST: "Misafir Ekle",
            SELECT_GUEST: "Misafir Seç",
            MONTH: "Misafir Seç",
            DAILY: "Günlük",
            WEEKLY: "Haftalık",
            MOVE_TO_TODAY: "Bugüne Taşı",
            HH: "HH",
            MARK_COMPLETED: "İŞARET TAMAMLANDI",
        },

        CONTACT: {
            CHAT: "Mesajlar",
            REACTION: "Tepkiler",
            THREADS: "Bağlı Mesajlar",
            LIKE_SMALL: "Beğeni",
            SEARCH_CONTACT: "Kişileri ara",
            CONTACT_LOG: "İletişim Günlüğü",
            TO_DO_S: "Yapılacaklar",
            CONTACTS: "Kişiler",
            CONTACTS_SMALL: "kişiler",
            ADD_EVENT_APPOINTMENT: "Etkinlik/Randevu Ekle",
            ADD_TO_DO: "Yapılacaklar Ekle",
            INTERNAL: "Dahili",
            EXTERNAL: "Harici",
            EDIT_CONTACT: "Kişiyi Düzenle",
        },

        FILE_EDITOR: {
            QUEUE_PROGRESS: "Sıra ilerlemesi:",
            QUEUE_LENGTH: "Kuyruk uzunluğu:",
            UPLOAD_QUEUE: "Yükleme kuyruğu",
            SINGLE: "Bekar",
            MULTIPLE: "çoklu",
            DROP_PHOTOS_HERE: "Fotoğrafları Buraya Bırakın",
            SELECTFILES: "SelectFiles",
            USER_DETAIL: "Kullanıcı Detayı",
            LOADING_DATA: "Veri yükleniyor...",
            NO_DATA: "Veri yok.",
        },

        BIP_BH_WELCOME: {
            TITLE: "Ödül Avcılarına Hoşgeldin",
            MESSAGE: "Burada sadece gerçek ödül avcıları ödül kazanabilir.",
            BUTTON: "Görevlere Katıl",
        },

        BIP_BH_MISSION: {
            TITLE: "Kolay Görev",
            MESSAGE: "BipMeet İndir ve Kullan",
            BUTTON: "Yap",
            POINT: "Puan",
        },

        BIP_BH_PROGRESS: {
            TIMER: "Kalan Zaman:",
            TITLE: "Ödül Avcıları",
            MESSAGE: "Burada sadece gerçek ödül avcıları ödül kazanabilir.",
            BUTTON: "Göreve Git",
            DAYS: "Gün",
            HOURS: "Saat",
            MINUTES: "Dakika",
            SECONDS: "Saniye",
        },

        BIP_CONTEST: {
            TITLE: "Yarışmalar",
            MESSAGE: "Burada sadece gerçek ödül avcıları ödül kazanabilir.",
            BUTTON1: "Turkcell Ödül Avcıları",
            BUTTON2: "Youtube Ödül Avcıları",
        },

        BIP_EARNED: {
            TITLE: "Tebrikler",
            MESSAGE: "Haftalık 2 GB kazandınız!",
            BUTTON: "Sosyal Medyada Paylaş",
        },

        BIP_EARNED_LIST: {
            TITLE: "Turkcell Ödül Avcıları",
            MESSAGE: "Kazanılan Toplam Puan",
            ITEM1: "10+ Yıl Turkcell Üyeliği",
            ITEM2: "BipMeet indir ve kullan",
        },

        BIP_MISSION_LIST: {
            MISSIONTYPE: "Kolay Görevler",
            MENU1: "Aktif Görevler",
            MENU2: "Eski Görevler",
            MENU3: "Yardım",
            TITLE: "Turkcell Ödül Avcıları",
            BUTTON: "Start New Race",
        },

        BIP_MISSION_TYPE: {
            TITLE: "Turkcell Ödül Avcıları",
            SUBTITLE: "Görev Tipleri",
            MISSIONTYPE1: "Kolay Görevler",
            MISSIONTYPE2: "Normal Görevler",
            MISSIONTYPE3: "Süper Görevler",
        },

    },
};
